import React, {
  startTransition,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import useToastContext from 'hooks/useToastContext';
import { useForm } from 'react-hook-form';
import ErrorMessage from 'components/ErrorMessage';
import { isEmpty, orderBy, get as __get } from 'lodash';
import OInputField from 'components/reusable/OInputField';
import { useTranslation } from 'react-i18next';
import ODatePicker from 'components/shared/datePicker/ODatePicker';
import { apiGet, apiPost, apiPut } from 'utils/apiFetch';
import apiPath from 'utils/apiPath';
import OSelect from 'components/reusable/OSelect';
import formValidation from 'utils/formValidation';
import OImage from 'components/reusable/OImage';
import { AiFillCamera } from 'react-icons/ai';
import defaultDeveloperImage from '../../assets/images/defaultDeveloperImage.jpg';
import { useLocation, useNavigate } from 'react-router-dom';
import OAmenities from 'components/reusable/OAmenities';
import { TagsInput } from 'react-tag-input-component';
import OPropertyCategories from 'components/reusable/OPropertyCategories';
import {
  AREA_BOUND,
  AREA_REGION,
  COUNTRY_RESTRICTIONS,
  PROPERTY_ALLOWED_PHOTO_EXT,
} from '../../utils/constants';
import photoClose from '../../assets/images/photo_close.png';
import OMapContainer from 'components/reusable/OMapContainer';
import AuthContext from 'context/AuthContext';
import helper from 'utils/helpers';
import ReactQuill from 'react-quill';
import { FaFilePdf } from 'react-icons/fa';
import Select from 'pages/test_manager/components/Input/Select';
import { BsEye } from 'react-icons/bs';
import { BiTrash } from 'react-icons/bi';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

const imageCount = 6;
const imageCountMax = 10;
const MAX_CONSTRUCTION_ASSETS = 15;
const MAX_INFOGRAPHY = 15;
const MAX_CONTRACT = 10;

const AddProject = () => {
  const { t } = useTranslation();
  const { config } = useContext(AuthContext);
  const notification = useToastContext();
  const location = useLocation();
  const navigate = useNavigate();
  const [editProperty, setEditProperty] = useState(location?.state?.item ?? '');
  const [createVideoUrl, setCreateVideoUrl] = useState(
    editProperty?.video ?? [],
  );
  const {
    register,
    setValue,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'onChange', shouldFocusError: true, defaultValues: {} });

  const photosRef = useRef();
  const galleryPhotosRef = useRef();
  const constructionAssetsRef = useRef();
  const infographyRef = useRef();
  const developerImageRef = useRef();
  const amenities = editProperty?.amenities?.map((item) => item?._id);
  const propertyCategory = editProperty?.propertyCategory?.map(
    (item) => item?._id,
  );
  const [isExclusive, setIsExclusive] = useState(false);
  const [isMostPopular, setIsMostPopular] = useState(false);
  const [description, setDescription] = useState('');
  const [descriptionAr, setDescriptionAr] = useState('');
  const [propertyCategoryTypes, setPropertyCategoryTypes] = useState([]);
  const [propertyCategoryType, setPropertyCategoryType] = useState(
    propertyCategory ?? [],
  );
  const [propertyAmenitiesList, setPropertyAmenitiesList] = useState([]);
  const [propertyAmenities, setPropertyAmenities] = useState(
    amenities?.length > 0 ? amenities : [],
  );
  const [deliveryDate, setDeliveryDate] = useState(
    editProperty?.handOverDate
      ? new Date(editProperty?.handOverDate).toString()
      : '',
  );

  const [photos, setPhotos] = useState(
    Array.isArray(editProperty?.photos) ? editProperty.photos : [],
  );
  const initialGalleryPhotos = Array.isArray(editProperty?.galleryPhotos)
    ? editProperty.galleryPhotos
    : Array.isArray(editProperty?.artGallary)
    ? editProperty.artGallary
    : [];
  const [galleryPhotos, setGalleryPhotos] = useState(initialGalleryPhotos);
  const [developerImage, setDeveloperImage] = useState('');
  const [developerDoc, setDeveloperDoc] = useState('');
  const [paymentPlan, setPaymentPlan] = useState('');
  const [edm, setEdm] = useState('');
  const [contractFiles, setContractFiles] = useState([]);
  const [existingContracts, setExistingContracts] = useState(
    Array.isArray(editProperty?.contract) ? editProperty.contract : [],
  );
  const [deletedContracts, setDeletedContracts] = useState([]);
  const [projectFloorPlan, setProjectFloorPlan] = useState('');
  const [videoFile, setVideoFile] = useState(editProperty?.video ?? []);
  const initialConstructionMedia = Array.isArray(
    editProperty?.constructionAssets,
  )
    ? editProperty.constructionAssets
    : [];
  const constructionPreviewFromStored = (entry) => {
    if (!entry) return '';
    if (typeof entry === 'string') return entry;
    if (typeof entry === 'object') {
      if (typeof entry.filename === 'string') return entry.filename;
      if (typeof entry.url === 'string') return entry.url;
    }
    return '';
  };
  const [createConstructionAssets, setCreateConstructionAssets] = useState(
    initialConstructionMedia.map(constructionPreviewFromStored),
  );
  const [constructionAssetsFiles, setConstructionAssetsFiles] = useState([
    ...initialConstructionMedia,
  ]);
  const [deletedConstructionAssets, setDeletedConstructionAssets] = useState(
    [],
  );
  const initialInfography = Array.isArray(editProperty?.infography)
    ? editProperty.infography
    : [];
  const [createInfography, setCreateInfography] = useState(
    initialInfography.map(constructionPreviewFromStored),
  );
  const [infographyFiles, setInfographyFiles] = useState([
    ...initialInfography,
  ]);
  const [deletedInfography, setDeletedInfography] = useState([]);
  const [deletedImage, setDeletedImage] = useState([]);
  const [deletedGalleryPhotos, setDeletedGalleryPhotos] = useState([]);
  const [deletedVideo, setDeletedVideo] = useState([]);
  const [deletedFloorPlan, setDeletedFloorPlan] = useState([]);
  const [isDeletePhoto, setIsDeletePhoto] = useState(false);
  const [isAmenity, setIsAmenity] = useState('');
  const [isShowModal, setIsShowModal] = useState(false);

  const [developerImgError, setDeveloperImgError] = useState('');
  const [developerDocError, setDeveloperDocError] = useState('');
  const [paymentPlanError, setPaymentPlanError] = useState('');
  const [edmError, setEdmError] = useState('');
  const [contractError, setContractError] = useState('');
  const [projectFloorPlanError, setProjectFloorPlanError] = useState('');
  const [isStartDateError, setIsStartDateError] = useState(false);

  const initialAvailabilityStatus = useRef(
    location?.state?.item?.availableStatus,
  );
  const [floorData, setFloorData] = useState([
    {
      titleFloorPlan: '',
      titleFloorPlanAr: '',
      image: '',
    },
  ]);
  const [paymentPercent, setPaymentPercent] = useState([
    {
      paymentTitle: '',
      paymentTitleAr: '',
      percentage: '',
    },
  ]);
  let selectedPhotos = [];
  let postCode = '';
  const [isAmenities, setIsAmenities] = useState(false);
  const [isPropertyCategories, setIsPropertyCategories] = useState(false);
  const [city, setCity] = useState('');
  const [nearestFacility, setNearestFacility] = useState([]);
  const [isPropertyCategory, setIsPropertyCategory] = useState('');

  const [community, setCommunity] = useState('');
  const [subCommunity, setSubCommunity] = useState('');

  const [markerPosition, setMarkerPosition] = useState(
    !isEmpty(editProperty)
      ? {
          lat: parseFloat(editProperty?.latitude),
          lng: parseFloat(editProperty?.longitude),
        }
      : AREA_REGION[config.country],
  );
  const [center, setCenter] = useState(
    !isEmpty(editProperty)
      ? {
          lat: parseFloat(editProperty?.latitude),
          lng: parseFloat(editProperty?.longitude),
        }
      : AREA_REGION[config.country],
  );
  const [nearestFacilityAr, setNearestFacilityAr] = useState([]);

  const [cities, setCities] = useState([]);

  const [selectedCity, setSelectedCity] = useState('');
  const [selectedCommunity, setSelectedCommunity] = useState('');
  const [selectedSubCommunity, setSelectedSubCommunity] = useState('');
  const [communities, setCommunities] = useState([]);
  const [subCommunities, setSubCommunities] = useState([]);
  const [selectedProjectStatus, setSelectedProjectStatus] = useState('');
  const [selectedConstructionStatus, setSelectedConstructionStatus] =
    useState('');
  const [statusOption, setStatusOption] = useState([]);
  const [availableOption, setAvailableOption] = useState([]);
  const [nearestFacilityApp, setNearestFacilityApp] = useState([]);
  const [nearestFacilityAppAr, setNearestFacilityAppAr] = useState([]);
  const [wafiFiles, setWafiFiles] = useState({
    logo: location?.state?.item?.wafiLogo || null,
    contract: location?.state?.item?.wafiContract || null,
    contractName: location?.state?.item?.wafiContractName || null,
  });
  const [selectedProjectType, setSelectedProjectType] = useState('');
  const [typeOption, setTypeOption] = useState([]);
  const [isNotify, setisNotify] = useState(false);
  const [preLaunch, setPreLaunch] = useState(false);
  const [showOnMap, setShowOnMap] = useState(false);
  const [showInWebsite, setShowInWebsite] = useState(false);
  const [showInAgentApp, setShowInAgentApp] = useState(false);
  const [showInCustomerApp, setShowInCustomerApp] = useState(false);

  const [projectShowInWebsite, setProjectShowInWebsite] = useState(false);
  const [projectShowInAgentApp, setProjectShowInAgentApp] = useState(false);
  const [projectShowInCustomerApp, setProjectShowInCustomerApp] =
    useState(false);

  const [isSignature, setIsSignature] = useState(false);
  const [showBrochureToFreelancer, setShowBrochureToFreelancer] =
    useState(false);
  const [showFloorPlanToFreelancer, setShowFloorPlanToFreelancer] =
    useState(false);
  const [showPaymentPlanToFreelancer, setShowPaymentPlanToFreelancer] =
    useState(false);
  const [showEdmToFreelancer, setShowEdmToFreelancer] = useState(false);
  const [showArtGalleryToFreelancer, setShowArtGalleryToFreelancer] =
    useState(false);
  const [showVideoToFreelancer, setShowVideoToFreelancer] = useState(false);
  const [banks, setBanks] = useState(null);
  const [selectedBank, setSelectedBank] = useState(null);
  const [freelancerAgents, setFreelancerAgents] = useState([]);
  const [selectedAgents, setSelectedAgents] = useState([]);
  const purposeTypeOption = [
    {
      key: 'Residential',
      value: 'residential',
    },
    {
      key: 'Commercial',
      value: 'commercial',
    },
  ];

  const projectOrderOption = Array.from({ length: 50 }, (_, i) => ({
    key: i + 1,
    value: i + 1,
  }));

  const constructionStatusOptions = [
    { key: 'Planning Stage', value: 'Planning Stage' },
    { key: 'Construction Started', value: 'Construction Started' },
    { key: 'Under Construction 25%', value: 'Under Construction 25%' },
    { key: 'Under Construction 50%', value: 'Under Construction 50%' },
    { key: 'Under Construction 70%', value: 'Under Construction 70%' },
    { key: 'Under Construction 90%', value: 'Under Construction 90%' },
    {
      key: 'Near Completion – Final Stages',
      value: 'Near Completion – Final Stages',
    },
    {
      key: 'Completed / Ready to move in',
      value: 'Completed / Ready to move in',
    },
  ];

  useEffect(() => {
    const fetchBanks = async () => {
      try {
        const response = await apiGet(apiPath.banks, { pageSize: 1000 });
        const data = response?.data?.results?.docs;
        if (data) {
          setBanks(data || []);
          if (editProperty?.bankId) {
            setSelectedBank(editProperty?.bankId);
          } else {
            setSelectedBank(data[0]?._id || null);
          }
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchBanks();
  }, [editProperty?.bankId]);

  useEffect(() => {
    const fetchFreelancerAgents = async () => {
      try {
        const response = await apiGet(apiPath.freelancerAgents);
        const data = response?.data?.results || [];
        const agents = Array.isArray(data) ? data : [];
        setFreelancerAgents(agents);
        if (!isEmpty(editProperty?.agentIds) && agents.length > 0) {
          const selectedIds = editProperty.agentIds.map((id) =>
            String(id?._id || id),
          );
          setSelectedAgents(
            agents.filter((agent) => selectedIds.includes(String(agent._id))),
          );
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchFreelancerAgents();
  }, [editProperty?.agentIds]);

  useEffect(() => {
    getProjectStatus(editProperty?.projectStatus);
    getProjectType(editProperty?.projectType);
    getProjectAavailableStatus(editProperty?.availableStatus);
  }, []);
  // Update selectedProjectStatus when editProperty.projectStatus changes (e.g., from API response)
  useEffect(() => {
    if (editProperty?.projectStatus && statusOption.length > 0) {
      setSelectedProjectStatus(editProperty.projectStatus);
      setValue('projectStatus', editProperty.projectStatus);
    }
  }, [editProperty?.projectStatus, statusOption.length, setValue]);

  useEffect(() => {
    if (editProperty?.projectType && typeOption.length > 0) {
      setSelectedProjectType(editProperty.projectType);
      setValue('projectType', editProperty.projectType);
    }
  }, [editProperty?.projectType, typeOption.length, setValue]);

  useEffect(() => {
    if (editProperty?.availableStatus && availableOption.length > 0) {
      setValue('availableStatus', editProperty.availableStatus);
    }
  }, [editProperty?.availableStatus, availableOption.length, setValue]);

  const getProjectAavailableStatus = async (availableStatus = '') => {
    try {
      const path = apiPath.availableStatus;
      const result = await apiGet(path);
      const { status, data } = result;
      if (status === 200) {
        setAvailableOption(
          data?.results?.map((res) => {
            return { key: res.name, value: res.value };
          }),
        );
        startTransition(() => {
          setValue('availableStatus', availableStatus);
        });
      }
    } catch (error) {
      console.log('error==>>>>', error.message);
    }
  };

  const getProjectStatus = async (projectStatus = '') => {
    try {
      const path = apiPath.getProjectStatus;
      const result = await apiGet(path);
      const { status, data } = result;
      if (status === 200) {
        setStatusOption(
          data?.results?.map((res) => {
            return { key: res.name, value: res.value };
          }),
        );
        startTransition(() => {
          setValue('projectStatus', projectStatus);
          console.log('projectStatus==>>>>', projectStatus);
          setSelectedProjectStatus(projectStatus);
        });
      }
    } catch (error) {
      console.log('error==>>>>', error.message);
    }
  };

  const getProjectType = async (projectType = '') => {
    try {
      const path = apiPath.getProjectType;
      const result = await apiGet(path);
      const { status, data } = result;
      if (status === 200) {
        setTypeOption(
          data?.results?.map((res) => {
            return { key: res.name, value: res.slug };
          }),
        );
        startTransition(() => {
          setValue('projectType', projectType);
          setSelectedProjectType(projectType);
        });
      }
    } catch (error) {
      console.log('error==>>>>', error.message);
    }
  };

  const handleCategoryChangeType = (property) => {
    // setPropertyCategoryType(property?._id || null)
    if (propertyCategoryType.includes(property?._id)) {
      const tempPropertyCategory = propertyCategoryType.filter(
        (selectedOption) => selectedOption !== property?._id,
      );
      setPropertyCategoryType(tempPropertyCategory);
      if (tempPropertyCategory?.length === 0) {
        setIsPropertyCategory('Please select property category.');
      }
    } else {
      setPropertyCategoryType([...propertyCategoryType, property?._id]);
      setIsPropertyCategory('');
    }
  };

  const addMoreNearestFacilityApp = (type) => {
    if (type === 'ar') {
      setNearestFacilityAppAr([
        ...nearestFacilityAppAr,
        { name: '', distance: '' },
      ]);
    } else {
      setNearestFacilityApp([
        ...nearestFacilityApp,
        { name: '', distance: '' },
      ]);
    }
  };

  const handleSubmitForm = async (data) => {
    let isValid = true;
    isValid = checkValidation();
    if (!isValid) return;
    let updatedPhotos = [...photos];
    try {
      const temp = floorData?.filter((res) => {
        return res.titleFloorPlan !== '' && res.image !== '';
      });
      const filterPaymentPercentage = paymentPercent?.filter((res) => {
        return (
          res.paymentTitle !== '' &&
          res.paymentTitleAr !== '' &&
          res.percentage !== ''
        );
      });
      const formData = new FormData();
      formData.append('bankId', selectedBank);
      formData.append('cameraZoomLevel', data?.cameraZoomLevel);
      formData.append('cameraPosition', JSON.stringify(data?.cameraPosition));
      formData.append(
        'titleFloorPlan',
        JSON.stringify(
          temp?.map((res) => {
            return res.titleFloorPlan;
          }),
        ),
      );
      formData.append(
        'titleFloorPlanAr',
        JSON.stringify(
          temp?.map((res) => {
            return res.titleFloorPlanAr;
          }),
        ),
      );
      for (let i = 0; i < temp?.length; i++) {
        formData.append('floorPlan', temp[i].image);
      }
      formData.append('title', data?.title);
      formData.append('availableStatus', data?.availableStatus);
      formData.append('titleAr', data?.titleAr);
      formData.append('sub_title', data?.sub_title);
      formData.append('sub_titleAr', data?.sub_titleAr);
      // formData.append('address', data?.address)
      formData.append('metaTitle', data?.metaTitle);
      formData.append('metaDescription', data?.metaDescription);
      formData.append('keyword', data?.keyword);
      formData.append('metaTitleAr', data?.metaTitleAr);
      formData.append('metaDescriptionAr', data?.metaDescriptionAr);
      formData.append('keywordAr', data?.keywordAr);
      formData.append('propertyCategory', propertyCategoryType);
      formData.append('projectStatus', data?.projectStatus);
      formData.append('constructionStatus', data?.constructionStatus ?? '');
      formData.append('projectType', data?.projectType);
      formData.append('purposeType', data?.purposeType);
      formData.append('projectOrder', data?.projectOrder);
      formData.append('startingPrice', data?.startingPrice);
      formData.append('handOverDate', deliveryDate);
      formData.append('isExclusive', isExclusive);
      formData.append('isMostPopular', isMostPopular);
      formData.append('isNotify', isNotify);
      formData.append('preLaunch', preLaunch);
      formData.append('showOnMap', showOnMap);
      formData.append('showInWebsite', showInWebsite);
      formData.append('showInAgentApp', showInAgentApp);
      formData.append('showInCustomerApp', showInCustomerApp);

      formData.append('projectShowInWebsite', projectShowInWebsite);
      formData.append('projectShowInAgentApp', projectShowInAgentApp);
      formData.append('projectShowInCustomerApp', projectShowInCustomerApp);
      formData.append('isSignature', isSignature);
      formData.append('showBrochureToFreelancer', showBrochureToFreelancer);
      formData.append('showFloorPlanToFreelancer', showFloorPlanToFreelancer);
      formData.append(
        'showPaymentPlanToFreelancer',
        showPaymentPlanToFreelancer,
      );
      formData.append('showEdmToFreelancer', showEdmToFreelancer);
      formData.append('showArtGalleryToFreelancer', showArtGalleryToFreelancer);
      formData.append('showVideoToFreelancer', showVideoToFreelancer);
      formData.append('minBedrooms', data?.minBedrooms || '');

      if (data?.maxBedrooms) {
        formData.append('maxBedrooms', data?.maxBedrooms);
      } else {
        formData.append('maxBedrooms', '');
      }

      formData.append('minBathrooms', data?.minBathrooms || '');

      if (data?.maxBathrooms) {
        formData.append('maxBathrooms', data?.maxBathrooms || null);
      } else {
        formData.append('maxBathrooms', '');
      }

      formData.append('minLivingRooms', data?.minLivingRooms || '');

      formData.append('minGuestRooms', data?.minGuestRooms || '');

      if (data?.maxLivingRooms) {
        formData.append('maxLivingRooms', data?.maxLivingRooms);
      } else {
        formData.append('maxLivingRooms', '');
      }
      if (data?.maxGuestRooms) {
        formData.append('maxGuestRooms', data?.maxGuestRooms);
      } else {
        formData.append('maxGuestRooms', '');
      }

      formData.append('minPropertySize', data?.minPropertySize);
      if (data?.maxPropertySize) {
        formData.append('maxPropertySize', data?.maxPropertySize);
      } else {
        formData.append('maxPropertySize', '');
      }

      if (data.pricePerSqFt === null) {
        formData.append('pricePerSqFt', 0);
      } else {
        formData.append('pricePerSqFt', data?.pricePerSqFt);
      }

      formData.append('developerName', data?.developerName);
      formData.append('developerNameAr', data?.developerNameAr);
      nearestFacilityApp.forEach((item, index) => {
        const itemJson = JSON.stringify(item);
        formData.append(`nearestFacilityApp[${index}]`, itemJson);
      });
      nearestFacilityAppAr.forEach((item, index) => {
        const itemJson = JSON.stringify(item);
        formData.append(`nearestFacilityAppAr[${index}]`, itemJson);
      });
      // formData.append('nearestFacilityApp', JSON.stringify(nearestFacilityApp))
      // formData.append('nearestFacilityAppAr', JSON.stringify(nearestFacilityAppAr))
      formData.append(
        'nearestFacility',
        JSON.stringify(nearestFacility?.map((facility) => facility.trim())),
      );
      formData.append(
        'nearestFacilityAr',
        JSON.stringify(
          nearestFacilityAr?.map((facilityAr) => facilityAr.trim()),
        ),
      );
      if (filterPaymentPercentage?.length > 0) {
        formData.append(
          'paymentPercent',
          JSON.stringify(filterPaymentPercentage),
        );
      }
      formData.append('street', data?.street);
      formData.append('streetAr', data?.streetAr);
      formData.append('unitNumber', data?.unitNumber);
      formData.append('licenseNumber', data?.licenseNumber);
      formData.append('appBrochure', data?.appBrochure);
      formData.append('url360', data?.url360);
      formData.append('latitude', data?.latitude);
      formData.append('longitude', data?.longitude);
      formData.append('building', data?.building);
      formData.append('buildingAr', data?.buildingAr);
      formData.append('description', description);
      formData.append('descriptionAr', descriptionAr);
      formData.append('amenities', propertyAmenities);
      formData.append(
        'agentIds',
        selectedAgents.map((agent) => agent._id).join(','),
      );
      formData.append('developerImage', developerImage);
      formData.append('developerDoc', developerDoc);
      formData.append('paymentPlan', paymentPlan);
      formData.append('edm', edm);
      contractFiles.forEach((file) => {
        formData.append('contract', file);
      });
      if (deletedContracts?.length > 0) {
        formData.append('deleteContracts', JSON.stringify(deletedContracts));
      }
      formData.append('projectFloorPlan', projectFloorPlan);
      formData.append('postCode', postCode);
      formData.append('cityId', data?.cityId);
      formData.append('communityId', data?.communityId);
      if (data?.subCommunityId) {
        formData.append('subCommunityId', data?.subCommunityId);
      } else {
        formData.append('subCommunityId', '');
      }
      formData.append('city', city);
      formData.append('community', community);
      formData.append('subCommunity', subCommunity);
      formData.append('accountName', data?.accountName || '');
      formData.append('accountNameAr', data?.accountNameAr || '');
      formData.append('bankName', data?.bankName || '');
      formData.append('bankNameAr', data?.bankNameAr || '');
      formData.append('iban', data?.iban || '');
      formData.append(
        'downPaymentPercentage',
        data?.downPaymentPercentage || 0,
      );
      // if (markerPosition) {
      //   formData.append('latitude', markerPosition.lat);
      //   formData.append('longitude', markerPosition.lng);
      // }
      videoFile.forEach((file) => {
        formData.append('video', file);
      });
      constructionAssetsFiles.forEach((file) => {
        formData.append('constructionAssets', file);
      });
      infographyFiles.forEach((file) => {
        formData.append('infography', file);
      });

      if (deletedImage?.length > 0) {
        formData.append('deletePhotos', JSON.stringify(deletedImage));
      }
      if (deletedGalleryPhotos?.length > 0) {
        formData.append(
          'deleteArtGallary',
          JSON.stringify(deletedGalleryPhotos),
        );
      }
      if (updatedPhotos?.length > 0) {
        for (let i = 0; i < updatedPhotos?.length; i++) {
          const dbUrl = updatedPhotos[i]?.split(
            config?.country === 'Saudi' ? 'o/' : 'net/',
          );
          formData.append('photos', dbUrl[1]);
        }
      }
      if (galleryPhotos?.length > 0) {
        for (let i = 0; i < galleryPhotos?.length; i++) {
          const dbUrl = galleryPhotos[i]?.split(
            config?.country === 'Saudi' ? 'o/' : 'net/',
          );
          formData.append('artGallary', dbUrl[1]);
        }
      }
      if (deletedFloorPlan?.length > 0) {
        formData.append('deleteFloorPlan', JSON.stringify(deletedFloorPlan));
      }
      if (deletedVideo?.length > 0) {
        formData.append('deleteVideos', JSON.stringify(deletedVideo));
      }
      if (deletedConstructionAssets?.length > 0) {
        formData.append(
          'deleteConstructionAssets',
          JSON.stringify(deletedConstructionAssets),
        );
      }
      if (deletedInfography?.length > 0) {
        formData.append('deleteInfography', JSON.stringify(deletedInfography));
      }
      if (data?.slug) {
        formData.append('slug', data?.slug);
      }
      if (data?.slugAr) {
        formData.append('slugAr', data?.slugAr);
      }

      if (wafiFiles?.logo && typeof wafiFiles?.logo === 'string') {
        const dbUrl = wafiFiles?.logo?.split(
          config?.country === 'Saudi' ? '/o/' : '/net/',
        );

        formData.append(
          'wafiLogo',
          dbUrl.length > 0 ? dbUrl[dbUrl.length - 1] : null,
        );
      } else {
        formData.append('wafiLogo', wafiFiles?.logo);
      }

      if (wafiFiles?.contract && typeof wafiFiles?.contract === 'string') {
        const dbUrl = wafiFiles?.contract?.split(
          config?.country === 'Saudi' ? '/o/' : '/net/',
        );
        formData.append(
          'wafiContract',
          dbUrl.length > 0 ? dbUrl[dbUrl.length - 1] : null,
        );
      } else {
        formData.append('wafiContract', wafiFiles?.contract);
      }
      if (isNotify === true) {
        if (
          (initialAvailabilityStatus.current === 'available' &&
            editProperty.availableStatus === 'coming-soon') ||
          editProperty.availableStatus === 'coming-soon'
        ) {
          formData.set('isNotify', 'true');
        }
      }

      if (!isEmpty(editProperty)) {
        const { data: response } = await apiPut(
          apiPath.projectPath + '/' + editProperty._id,
          formData,
        );
        if (response?.success) {
          notification.success(response?.message);
          navigate('/projects');
        } else {
          notification.error(response?.message);
        }
      } else {
        const { data: response } = await apiPost(apiPath.projectPath, formData);

        if (response?.success) {
          notification.success(response?.message);
          navigate('/projects');
        } else {
          notification.error(response?.message);
        }
      }
    } catch (err) {
      console.error('err:', err);
      notification.error(err?.message);
    }
  };
  const getCities = async (
    countryName = '',
    ciyId = '',
    communityId = '',
    subCommunityId = '',
  ) => {
    try {
      const payload = {};
      const path = apiPath.citiesListForAddress;
      const result = await apiGet(path, payload);
      const records = result?.data?.results;
      setCities(records);

      setValue('cityId', ciyId);
      setSelectedCity(ciyId);
      addressChanged({
        selectedCity: ciyId,
        update: true,
      });
      await getCommunities(ciyId, { communityId, subCommunityId });
    } catch (error) {
      console.error('error in get all users list==>>>>', error.message);
    }
  };
  const fetchMasterRecords = async (data) => {
    try {
      const payload = { ...data };
      const path = apiPath.PropertiesMasterData;
      const result = await apiGet(path, payload);
      const records = result?.data?.results;
      // setPropertyCategoryTypes(records?.propertyCategories || [])
      const propertyTypes = records?.propertyTypes?.find(
        (res) => res.type === 'Project',
      );
      setPropertyCategoryTypes(
        records?.propertyCategories?.filter(
          (pt) => pt.propertyTypeId === propertyTypes?._id,
        ),
      );
      setPropertyAmenitiesList(records?.propertyAmenities || []);
    } catch (error) {
      console.error('error in get all users list==>>>>', error.message);
    }
  };
  useEffect(() => {
    fetchMasterRecords();
    if (!isEmpty(editProperty)) {
      getCities(
        editProperty?.country || 'UAE',
        editProperty?.cityId || '',
        editProperty?.communityId || '',
        editProperty?.subCommunityId || '',
      );
      setValue('cameraZoomLevel', editProperty?.cameraZoomLevel || '');
      setValue(
        'cameraPosition.latitude',
        editProperty?.cameraPosition?.latitude || '',
      );
      setValue(
        'cameraPosition.longitude',
        editProperty?.cameraPosition?.longitude || '',
      );
      setValue('latitude', editProperty?.latitude || '');
      setValue('longitude', editProperty?.longitude || '');
      setValue('title', editProperty?.title);
      setValue('titleAr', editProperty?.titleAr);
      setValue('sub_title', editProperty?.sub_title);
      setValue('sub_titleAr', editProperty?.sub_titleAr);
      //setValue('projectStatus', editProperty?.projectStatus)
      setValue('purposeType', editProperty?.purposeType);
      setValue('projectOrder', editProperty?.projectOrder);
      setValue('startingPrice', editProperty?.startingPrice);
      setValue('availableStatus', editProperty?.availableStatus);
      setValue('constructionStatus', editProperty?.constructionStatus ?? '');
      setSelectedConstructionStatus(editProperty?.constructionStatus ?? '');
      setValue('minBedrooms', editProperty?.minBedrooms);
      setValue('isExclusive', editProperty?.isExclusive || false);
      setValue('isMostPopular', editProperty?.isMostPopular || false);
      setIsExclusive(editProperty?.isExclusive || false);
      setIsMostPopular(editProperty?.isMostPopular || false);
      if (editProperty?.maxBedroom === null) {
        setValue('maxBedrooms', '');
      } else {
        setValue('maxBedrooms', editProperty?.maxBedrooms);
      }

      setValue('minBathrooms', editProperty?.minBathrooms);
      if (editProperty?.maxBathrooms === null) {
        setValue('maxBathrooms', '');
      } else {
        setValue('maxBathrooms', editProperty?.maxBathrooms);
      }

      setValue('minLivingRooms', editProperty?.minLivingRooms);
      if (editProperty?.maxLivingRooms === null) {
        setValue('maxLivingRooms', '');
      } else {
        setValue('maxLivingRooms', editProperty?.maxLivingRooms);
      }

      setValue('minGuestRooms', editProperty?.minGuestRooms);
      if (editProperty?.maxGuestRooms === null) {
        setValue('maxGuestRooms', '');
      } else {
        setValue('maxGuestRooms', editProperty?.maxGuestRooms);
      }

      setValue('minPropertySize', editProperty?.minPropertySize);
      if (editProperty?.maxPropertySize === null) {
        setValue('maxPropertySize', '');
      } else {
        setValue('maxPropertySize', editProperty?.maxPropertySize);
      }
      setValue('pricePerSqFt', editProperty?.pricePerSqFt);
      setValue('developerName', editProperty?.developerName);
      setValue('developerNameAr', editProperty?.developerNameAr);
      // setValue('nearestFacilities', editProperty?.nearestFacilities)
      // setValue('description', editProperty?.description)
      // setValue('descriptionAr', editProperty?.descriptionAr)
      if (editProperty?.description) setDescription(editProperty?.description);
      if (editProperty?.descriptionAr)
        setDescriptionAr(editProperty?.descriptionAr);
      setValue('developerImage', editProperty?.developerImage);
      setValue('developerDoc', editProperty?.developerDoc);
      setValue('paymentPlan', editProperty?.paymentPlan);
      setValue('edm', editProperty?.edm);
      setValue('contract', editProperty?.contract);
      setValue('projectFloorPlan', editProperty?.projectFloorPlan);
      setValue('video', editProperty?.video);
      setValue('photos', editProperty?.photos);
      setValue('artGallary', editProperty?.artGallary);
      setValue('floorPlan', editProperty?.floorPlan);
      setValue('address', editProperty?.address);
      setValue('slug', editProperty?.slug);
      setValue('slugAr', editProperty?.slugAr);
      setValue('metaTitle', editProperty?.metaTitle);
      setValue('metaDescription', editProperty?.metaDescription);
      setValue('keyword', editProperty?.keyword);
      setValue('metaTitleAr', editProperty?.metaTitleAr);
      setValue('metaDescriptionAr', editProperty?.metaDescriptionAr);
      setValue('keywordAr', editProperty?.keywordAr);
      setDeliveryDate(
        editProperty?.handOverDate
          ? new Date(editProperty?.handOverDate).toString()
          : '',
      );
      const defaultFloorData = editProperty?.floorPlan?.map((item) => {
        return {
          titleFloorPlan: item?.title,
          titleFloorPlanAr: item?.titleAr,
          image: item?.image,
        };
      });
      setFloorData(defaultFloorData);
      setValue('building', editProperty?.building);
      setValue('buildingAr', editProperty?.buildingAr);
      setValue('unitNumber', editProperty?.unitNumber);
      setValue('licenseNumber', editProperty?.licenseNumber);
      setValue('appBrochure', editProperty?.appBrochure);
      setValue('url360', editProperty?.url360 || '');

      setValue('street', editProperty?.street);
      setValue('streetAr', editProperty?.streetAr);

      if (editProperty?.nearestFacility?.length > 0) {
        setNearestFacility(editProperty.nearestFacility);
      }
      if (editProperty?.nearestFacilityAr?.length > 0) {
        setNearestFacilityAr(editProperty.nearestFacilityAr);
      }

      if (editProperty?.paymentPercent?.length > 0) {
        const tempPaymentPercentage = editProperty.paymentPercent;
        setPaymentPercent(tempPaymentPercentage);
      }

      setValue('communityId', editProperty?.communityId);
      setValue('subCommunityId', editProperty?.subCommunityId);
      setValue('cityId', editProperty?.cityId);
      setValue('accountName', editProperty?.accountName);
      setValue('accountNameAr', editProperty?.accountNameAr);
      setValue('bankName', editProperty?.bankName);
      setValue('bankNameAr', editProperty?.bankNameAr);
      setValue('iban', editProperty?.iban);
      setValue('downPaymentPercentage', editProperty?.downPaymentPercentage);

      setNearestFacilityApp(editProperty?.nearestFacilityApp || []);
      setNearestFacilityAppAr(editProperty?.nearestFacilityAppAr || []);
      setCity(editProperty?.city);
      setCommunity(editProperty?.community);
      setPreLaunch(editProperty?.preLaunch || false);
      setShowOnMap(editProperty?.showOnMap || false);
      setShowInWebsite(editProperty?.showInWebsite || false);
      setShowInAgentApp(editProperty?.showInAgentApp || false);
      setShowInCustomerApp(editProperty?.showInCustomerApp || false);
      setProjectShowInWebsite(editProperty?.projectShowInWebsite || false);
      setProjectShowInAgentApp(editProperty?.projectShowInAgentApp || false);
      setProjectShowInCustomerApp(
        editProperty?.projectShowInCustomerApp || false,
      );
      setIsSignature(editProperty?.isSignature || false);
      setShowBrochureToFreelancer(
        editProperty?.showBrochureToFreelancer || false,
      );
      setShowFloorPlanToFreelancer(
        editProperty?.showFloorPlanToFreelancer || false,
      );
      setShowPaymentPlanToFreelancer(
        editProperty?.showPaymentPlanToFreelancer || false,
      );
      setShowEdmToFreelancer(editProperty?.showEdmToFreelancer || false);
      setShowArtGalleryToFreelancer(
        editProperty?.showArtGalleryToFreelancer || false,
      );
      setShowVideoToFreelancer(editProperty?.showVideoToFreelancer || false);
      if (editProperty?.subCommunity)
        setSubCommunity(editProperty?.subCommunity);
    } else {
      getCities();
    }
  }, [editProperty]);

  const handleDateChange = (date) => {
    setDeliveryDate(date);
  };
  const singleVideo = (item) => {
    const getType = item.target.files[0].type.split('/');
    if (getType[0] !== undefined && getType[1] === 'mp4') {
      const fileSize = (item.target.files[0]?.size / (1024 * 1024)).toFixed(2);
      if (fileSize > 50) {
        notification.error('Please select video below 50 MB');
        return false;
      } else {
        return true;
      }
    } else {
      notification.error('Only mp4 video formats are allowed');
      return false;
    }
  };
  const multipleVideo = (item) => {
    for (let i = 0; i < item?.target?.files?.length; i++) {
      const getType = item.target.files[i].type.split('/');
      if (getType[0] !== undefined && getType[1] === 'mp4') {
        const fileSize = (item.target.files[i]?.size / (1024 * 1024)).toFixed(
          2,
        );
        if (fileSize > 50) {
          notification.error('Please select video below 50 MB');
          return false;
        } else {
          return true;
        }
      } else {
        notification.error('Only mp4 video formats are allowed');
      }
    }
  };

  const checkValidation = () => {
    let isValid = true;
    const updatedPhotos = [...photos];
    const updatedGalleryPhotos = [...galleryPhotos];

    // Count temporary images by type
    const tempProjectPhotos =
      tempImage?.filter((res) => res?.type === 'project') || [];
    const tempArtGallaryPhotos =
      tempImage?.filter((res) => res?.type === 'artGallary') || [];

    // Calculate total counts from current state only (avoid double count / double subtract)
    const totalProjectPhotos = updatedPhotos.length;
    const totalArtGallaryPhotos = updatedGalleryPhotos.length;

    if (
      editProperty?.photos?.length === 0 &&
      editProperty?.artGallary?.length === 0
    ) {
      // New project validation
      if (
        updatedPhotos?.length < imageCount &&
        updatedGalleryPhotos?.length < imageCount
      ) {
        notification.error('Please upload min 6 images.');
        return false;
      } else if (
        updatedPhotos?.length > imageCountMax &&
        updatedGalleryPhotos?.length > imageCountMax
      ) {
        notification.error('You can only select 10 image at a time');
        return false;
      }
    } else {
      // Existing project validation - validate project photos
      if (tempProjectPhotos.length > imageCountMax) {
        notification.error('You can only select 10 project images at a time');
        return false;
      }

      if (totalProjectPhotos > imageCountMax) {
        notification.error(
          `Project images should not be more than ${imageCountMax}`,
        );
        return false;
      } else if (totalProjectPhotos < imageCount) {
        notification.error(
          `Project images should not be less than ${imageCount}`,
        );
        return false;
      } else if (totalProjectPhotos > 20) {
        notification.error('Project images should not be more than 20');
        return false;
      }

      // Validate art gallery photos
      if (tempArtGallaryPhotos.length > imageCountMax) {
        notification.error(
          'You can only select 10 art gallery images at a time',
        );
        return false;
      }

      // Combined validation
      if (totalProjectPhotos === 0 && totalArtGallaryPhotos === 0) {
        notification.error('Please upload min 6 images.');
        return false;
      }
    }
    if (!propertyCategoryType || propertyCategoryType.length < 1) {
      isValid = false;
      setIsPropertyCategory('Please select property category.');
    } else {
      // isValid = true
      setIsPropertyCategory('');
    }
    if (propertyAmenities?.length === 0) {
      isValid = false;
      setIsAmenity('Please select amenities.');
    } else {
      // isValid = true
      setIsAmenity('');
    }
    return isValid;
  };
  const setDeleteIcon = () => {
    if (photos.length > 6) {
      setIsDeletePhoto(true);
    } else {
      setIsDeletePhoto(false);
    }
  };
  const [tempImage, setTempImage] = useState([]);
  // const removePhotos = item => {
  //   if (typeof item !== 'object') {
  //     const dbUrl = item?.split(config?.country === "Saudi" ? "o/" : "net/")
  //     setDeletedImage(prev => [...prev, dbUrl[1]])
  //     const filteredImages = photos.filter(image => image !== item)
  //     setPhotos(filteredImages)
  //   } else {
  //     const filteredImages = selectedPhotos.filter(image => image !== item)
  //     setSelectedPhotos(filteredImages)
  //   }
  // }

  const removePhotos = async (photosType, index) => {
    if (typeof index !== 'object') {
      let check =
        tempImage?.filter((res) => res?.type === photosType)?.length > 0
          ? tempImage?.find(
              (res) => res?.type === photosType && res?.image == index,
            )
          : {};
      if (!isEmpty(check)) {
        apiPut(apiPath.deleteTempPhoto + check?._id, { type: 'project' });
        setTempImage((prev) => {
          return prev?.filter(
            (res) => !(res?.type === photosType && res?.image == index),
          );
        });
        if (photosType === 'project') {
          setPhotos((prev) => {
            return prev?.filter((res) => res !== index);
          });
        } else if (photosType === 'artGallary') {
          setGalleryPhotos((prev) => {
            return prev?.filter((res) => res !== index);
          });
        }
      } else {
        const dbUrl = index?.split(config?.country === 'Saudi' ? 'o/' : 'net/');
        if (photosType === 'project') {
          setDeletedImage((prev) => [...prev, dbUrl[1]]);
          setPhotos((prev) => {
            return prev?.filter((res) => res !== index);
          });
        } else if (photosType === 'artGallary') {
          setDeletedGalleryPhotos((prev) => [...prev, dbUrl[1]]);
          setGalleryPhotos((prev) => {
            return prev?.filter((res) => res !== index);
          });
        }
      }
    }
    if (photosType === 'project') {
      setPhotos((prev) => {
        return prev.filter((res) => res !== index);
      });
    } else if (photosType === 'artGallary') {
      setGalleryPhotos((prev) => {
        return prev.filter((res) => res !== index);
      });
    }
  };

  const uploadTemporaryPhotos = async (photosType, e) => {
    const formData = new FormData();
    if (!isEmpty(editProperty?._id)) {
      formData.append('projectId', editProperty?._id);
    }
    formData.append('isSignature', isSignature);
    formData.append('image', e);

    const { data: response } = await apiPost(
      apiPath.uploadTemporaryPhotos,
      formData,
    );
    if (response.success) {
      setTempImage((prev) => {
        return [...prev, { type: photosType, image: response?.results?.image }];
      });
      if (photosType === 'project') {
        setPhotos((prev) => {
          return [...prev, response?.results?.image];
        });
      } else if (photosType === 'artGallary') {
        setGalleryPhotos((prev) => {
          return [...prev, response?.results?.image];
        });
      }
    } else {
      notification.error(response?.message);
    }
  };

  const handlePhotosChange = (photosType) => (e) => {
    const files = e.target.files;
    const tempFile = Object.values(files);
    if (photosType === 'project') {
      if ([...selectedPhotos, ...tempFile, ...photos]?.length < imageCount) {
        notification.error('Please upload min 6 images.');
        return false;
      }
    } else if (photosType === 'artGallary') {
      const safeGallery = Array.isArray(galleryPhotos) ? galleryPhotos : [];
      if ([...selectedPhotos, ...tempFile, ...safeGallery]?.length < 1) {
        notification.error('Please upload min 1 images.');
        return false;
      }
    }
    if ([...selectedPhotos, ...tempFile].length > imageCountMax) {
      if (selectedPhotos.length === 0 && [...tempFile].length > imageCountMax) {
        notification.error('Only 10 photos are allowed to upload at a time.');
      } else if (
        selectedPhotos.length === imageCountMax &&
        [...selectedPhotos, ...tempFile].length > imageCountMax
      ) {
        notification.error('Only 10 photos are allowed to upload at a time.');
      } else if ([...selectedPhotos, ...tempFile, ...photos].length > 20) {
        notification.error('Max 20 photos are allowed to upload.');
      } else {
        notification.error(
          `Now you select only ${
            imageCountMax - selectedPhotos.length
          } photos.`,
        );
      }
    } else {
      for (let i = 0; i < files?.length; i++) {
        const fileSize = helper.getFileSize(files[i]);
        const getType = files[i].type.split('/');
        if (PROPERTY_ALLOWED_PHOTO_EXT.includes(getType[1])) {
          if (fileSize > 2) {
            notification.error(
              'Please select photos below 2 MB (photos has been discarded which is above 2 MB)',
            );
          } else {
            uploadTemporaryPhotos(photosType, files[i]);
            // setSelectedPhotos(prev => {
            //   if (prev?.length > 0) {
            //     return [...prev, files[i]]
            //   } else {
            //     return [files[i]]
            //   }
            // })
          }
        } else {
          notification.error(
            `Only ${PROPERTY_ALLOWED_PHOTO_EXT.join(
              ', ',
            )} photos are allowed to upload.`,
          );
        }
      }
    }
  };

  const validateFiles = (developerPic) => {
    let picError = '';
    const supportedTypes = ['image/jpeg', 'image/jpg', 'image/png'];

    if (!isEmpty(supportedTypes.includes(developerPic.type))) {
      picError = 'Only jpeg, jpg and png are supported.';
    }

    if (picError) {
      setDeveloperImgError(picError);
      return false;
    } else {
      setDeveloperImgError('');
      return true;
    }
  };
  const handleDeveloperImageChange = (e) => {
    const image = e?.target?.files[0];
    const isValidImage = validateFiles(image);
    if (isValidImage) {
      setDeveloperImage(image);
    } else {
      setDeveloperImage(null);
    }
  };

  const validateDocFiles = (developeDoc, docType) => {
    let docError = '';
    const supportedTypes = [
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/pdf',
      'application/vnd.ms-powerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'application/rtf',
    ];

    if (!isEmpty(supportedTypes.includes(developeDoc.type))) {
      docError = 'Only pdf, doc, rtf and ppt files are supported.';
    }

    if (docType === 'brochure') {
      if (docError) {
        setDeveloperDocError(docError);
        return false;
      } else {
        setDeveloperDocError('');
        return true;
      }
    } else if (docType === 'paymentPlan') {
      if (docError) {
        setPaymentPlanError(docError);
        return false;
      } else {
        setPaymentPlanError('');
        return true;
      }
    } else if (docType === 'edm') {
      if (docError) {
        setEdmError(docError);
        return false;
      } else {
        setEdmError('');
        return true;
      }
    } else if (docType === 'contract') {
      if (docError) {
        setContractError(docError);
        return false;
      } else {
        setContractError('');
        return true;
      }
    } else if (docType === 'projectFloorPlan') {
      if (docError) {
        setProjectFloorPlanError(docError);
        return false;
      } else {
        setProjectFloorPlanError('');
        return true;
      }
    }
  };

  const handleBrochureChange = (e) => {
    const brochureFile = e?.target?.files[0];
    const isValid = validateDocFiles(brochureFile, 'brochure');
    if (isValid) {
      setDeveloperDoc(brochureFile);
    } else {
      setDeveloperDoc(null);
    }
  };

  const handlePaymentPlanChange = (e) => {
    const paymentPlanFile = e?.target?.files[0];
    const isValid = validateDocFiles(paymentPlanFile, 'paymentPlan');
    if (isValid) {
      setPaymentPlan(paymentPlanFile);
    } else {
      setPaymentPlan(null);
    }
  };

  const handleEdmChange = (e) => {
    const edmFile = e?.target?.files[0];
    const isValid = validateDocFiles(edmFile, 'edm');
    if (isValid) {
      setEdm(edmFile);
    } else {
      setEdm(null);
    }
  };

  const handleContractChange = (e) => {
    const incoming = [...(e?.target?.files || [])];
    if (!incoming.length) return;
    for (const file of incoming) {
      if (!validateDocFiles(file, 'contract')) {
        e.target.value = null;
        return;
      }
    }
    const nextCount =
      existingContracts.length + contractFiles.length + incoming.length;
    if (nextCount > MAX_CONTRACT) {
      notification.error(
        `Please select only ${MAX_CONTRACT} contract files.`,
      );
      e.target.value = null;
      return;
    }
    setContractFiles((prev) => [...prev, ...incoming]);
    e.target.value = null;
  };

  const removeNewContract = (index) => {
    setContractFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const removeExistingContract = (url) => {
    setExistingContracts((prev) => prev.filter((item) => item !== url));
    const dbUrl = String(url).split(
      config?.country === 'Saudi' ? 'o/' : 'net/',
    );
    const key = dbUrl[1];
    if (key) {
      setDeletedContracts((prev) => [...prev, key]);
    }
  };

  const handleProjectFloorPlanChange = (e) => {
    const projectFloorPlanFile = e?.target?.files[0];
    const isValid = validateDocFiles(projectFloorPlanFile, 'projectFloorPlan');
    if (isValid) {
      setProjectFloorPlan(projectFloorPlanFile);
    } else {
      setProjectFloorPlan(null);
    }
  };

  const getCommunities = async (cityId = '', option) => {
    try {
      const payload = { cityId };
      const path = apiPath.communityListByCityId;
      const result = await apiGet(path, payload);
      const records = result?.data?.results;
      if (result?.data?.success) {
        setCommunities(orderBy(records, ['name'], ['asc']));

        setValue('communityId', option?.communityId);
        setSelectedCommunity(option?.communityId);
        addressChanged({
          selectedCommunity: option?.communityId,
          update: true,
        });

        await getSubCommunities(option?.communityId, {
          subCommunityId: option?.subCommunityId,
        });
      } else {
        setSelectedCommunity('');
        setValue('community', '');
        setSelectedSubCommunity('');
        setValue('subCommunity', '');
      }
    } catch (error) {
      console.error('error in get all users list==>>>>', error.message);
    }
  };

  const getSubCommunities = async (communityId = '', option) => {
    try {
      const payload = { communityId: communityId };
      const path = apiPath.subCommunityListByCommunityId;
      const result = await apiGet(path, payload);
      const records = result?.data?.results;
      if (result?.data?.success) {
        setSubCommunities(orderBy(records, ['name'], ['asc']));

        setValue('subCommunityId', option?.subCommunityId);
        setSelectedSubCommunity(option?.subCommunityId);
        addressChanged({
          selectedSubCommunity: option?.subCommunityId,
          update: true,
        });
      } else {
        setSelectedCommunity('');
        setValue('community', '');
        setSelectedSubCommunity('');
        setValue('subCommunity', '');
      }
    } catch (error) {
      console.error('error in get all users list==>>>>', error.message);
    }
  };

  const handleCitySelect = (e) => {
    setSelectedCity(e.target.value);
    addressChanged({
      selectedCity: e.target.value,
    });
    setSelectedCommunity('');
    setSelectedSubCommunity('');
    setCommunities([]);
    setSubCommunities([]);
    getCommunities(e.target.value, {});
  };

  const handleCommunitySelect = (e) => {
    const communityId = e.target.value;
    setSelectedCommunity(communityId);
    addressChanged({ selectedCommunity: communityId });
    getSubCommunities(communityId, { communityId });
  };

  const addMoreFloor = () => {
    setFloorData([
      ...floorData,
      {
        titleFloorPlan: '',
        titleFloorPlanAr: '',
        image: '',
      },
    ]);
  };

  const addMorePaymentPercentage = () => {
    setPaymentPercent([
      ...paymentPercent,
      {
        paymentTitle: '',
        paymentTitleAr: '',
        percentage: '',
      },
    ]);
  };

  const removeVideo = (item) => {
    if (typeof item !== 'object') {
      const dbUrl = item?.split(config?.country === 'Saudi' ? 'o/' : 'net/');
      setDeletedVideo((prev) => [...prev, dbUrl[1]]);
    }
    const filteredVideo = createVideoUrl.filter(
      (videoItem) => videoItem !== item,
    );
    setVideoFile(filteredVideo);
    if (typeof item === 'object') {
      const tempVideo = [...videoFile];
      const tempVideoItem = URL.createObjectURL(item);
      tempVideo.push(tempVideoItem);
      setCreateVideoUrl(tempVideo);
    } else {
      setCreateVideoUrl(filteredVideo);
    }
  };

  const handleChange = (event) => {
    if (event.target.files) {
      let tempVideoArray = [...videoFile];
      const videosFile = Object.values(event.target.files);
      tempVideoArray = [...tempVideoArray, ...videosFile];
      if (event?.target?.files?.length === 1) {
        const isValid = singleVideo(event);
        if (!isValid) return;
      } else if (event?.target?.files?.length > 2) {
        const isValid = multipleVideo(event);
        if (!isValid) return;
      }
      if (tempVideoArray.length > 5) {
        notification.error('Please select only 5 video files.');
      } else {
        const tempVideo = [];
        const tempVideoFile = [];
        Object.values(event.target.files).map((item) => {
          if (item?.type?.includes('/mp4')) {
            tempVideo.push(URL.createObjectURL(item));
            tempVideoFile.push(item);
          }
        });
        setVideoFile([...videoFile, ...tempVideoFile]);
        const tempCreateVideo = [...tempVideo, ...createVideoUrl];
        setCreateVideoUrl(tempCreateVideo);
      }
    }
  };

  const validateConstructionMediaFile = (file) => {
    if (!file || !(file instanceof File)) return false;
    if (file.type.startsWith('video/')) {
      const parts = file.type.split('/');
      if (parts[1] !== 'mp4') {
        notification.error('Only mp4 video formats are allowed');
        return false;
      }
      const fileSize = (file.size / (1024 * 1024)).toFixed(2);
      if (fileSize > 50) {
        notification.error('Please select video below 50 MB');
        return false;
      }
      return true;
    }
    if (file.type.startsWith('image/')) {
      const fileSize = (file.size / (1024 * 1024)).toFixed(2);
      if (fileSize > 2) {
        notification.error('Please select images below 2 MB');
        return false;
      }
      const allowed = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
      if (!allowed.includes(file.type)) {
        notification.error('Only jpeg, png, jpg, gif formats are allowed');
        return false;
      }
      return true;
    }
    notification.error('Only images or mp4 videos are allowed');
    return false;
  };

  const validateMultipleConstructionMediaFiles = (files) => {
    for (let i = 0; i < files.length; i++) {
      if (!validateConstructionMediaFile(files[i])) return false;
    }
    return true;
  };

  const handleConstructionAssetsChange = (event) => {
    if (!event.target.files?.length) return;
    const incoming = [...event.target.files];
    if (incoming.length === 1) {
      if (!validateConstructionMediaFile(incoming[0])) {
        event.target.value = null;
        return;
      }
    } else if (!validateMultipleConstructionMediaFiles(incoming)) {
      event.target.value = null;
      return;
    }
    const nextCount = constructionAssetsFiles.length + incoming.length;
    if (nextCount > MAX_CONSTRUCTION_ASSETS) {
      notification.error(
        `Please select only ${MAX_CONSTRUCTION_ASSETS} construction media files.`,
      );
      event.target.value = null;
      return;
    }
    const previews = incoming.map((f) => URL.createObjectURL(f));
    setConstructionAssetsFiles((prev) => [...prev, ...incoming]);
    setCreateConstructionAssets((prev) => [...prev, ...previews]);
    event.target.value = null;
  };

  const removeConstructionAssetAt = (index) => {
    const removed = constructionAssetsFiles[index];
    setConstructionAssetsFiles((prev) => prev.filter((_, i) => i !== index));
    setCreateConstructionAssets((prev) => prev.filter((_, i) => i !== index));
    if (removed instanceof File) return;
    const raw =
      typeof removed === 'string'
        ? removed
        : removed?.filename ?? removed?.url ?? '';
    if (!raw) return;
    const dbUrl = raw.split(config?.country === 'Saudi' ? 'o/' : 'net/');
    const key = dbUrl[1];
    if (key) {
      setDeletedConstructionAssets((prev) => [...prev, key]);
    }
  };

  const isConstructionEntryVideo = (fileEntry, previewSrc) => {
    if (fileEntry instanceof File) {
      return fileEntry.type.startsWith('video/');
    }
    if (fileEntry && typeof fileEntry === 'object' && fileEntry.type) {
      return String(fileEntry.type).toLowerCase().includes('video');
    }
    return /\.(mp4|mov|webm|mkv)(\?|#|$)/i.test(String(previewSrc || ''));
  };

  const validateInfographyFile = (file) => {
    if (!file || !(file instanceof File)) return false;
    if (!file.type.startsWith('image/')) {
      notification.error('Only image files are allowed for infography');
      return false;
    }
    const allowed = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
    if (!allowed.includes(file.type)) {
      notification.error('Only jpeg, png, jpg, gif formats are allowed');
      return false;
    }
    const fileSize = (file.size / (1024 * 1024)).toFixed(2);
    if (fileSize > 2) {
      notification.error('Please select images below 2 MB');
      return false;
    }
    return true;
  };

  const validateMultipleInfographyFiles = (files) => {
    for (let i = 0; i < files.length; i++) {
      if (!validateInfographyFile(files[i])) return false;
    }
    return true;
  };

  const handleInfographyChange = (event) => {
    if (!event.target.files?.length) return;
    const incoming = [...event.target.files];
    if (incoming.length === 1) {
      if (!validateInfographyFile(incoming[0])) {
        event.target.value = null;
        return;
      }
    } else if (!validateMultipleInfographyFiles(incoming)) {
      event.target.value = null;
      return;
    }
    const nextCount = infographyFiles.length + incoming.length;
    if (nextCount > MAX_INFOGRAPHY) {
      notification.error(
        `Please select only ${MAX_INFOGRAPHY} infography files.`,
      );
      event.target.value = null;
      return;
    }
    const previews = incoming.map((f) => URL.createObjectURL(f));
    setInfographyFiles((prev) => [...prev, ...incoming]);
    setCreateInfography((prev) => [...prev, ...previews]);
    event.target.value = null;
  };

  const removeInfographyAt = (index) => {
    const removed = infographyFiles[index];
    setInfographyFiles((prev) => prev.filter((_, i) => i !== index));
    setCreateInfography((prev) => prev.filter((_, i) => i !== index));
    if (removed instanceof File) return;
    const raw =
      typeof removed === 'string'
        ? removed
        : removed?.filename ?? removed?.url ?? '';
    if (!raw) return;
    const dbUrl = raw.split(config?.country === 'Saudi' ? 'o/' : 'net/');
    const key = dbUrl[1];
    if (key) {
      setDeletedInfography((prev) => [...prev, key]);
    }
  };

  const handleFileUploadSingle = (e) => {
    const getType = e.target.files[0].type.split('/');
    const fileSize = (e.target.files[0]?.size / (1024 * 1024)).toFixed(2);
    if (
      getType[1] !== undefined &&
      (getType[1] === 'jpeg' ||
        getType[1] === 'png' ||
        getType[1] === 'jpg' ||
        getType[1] === 'gif')
    ) {
      if (fileSize > 2) {
        notification.error('Please select image below 2 MB');
        return false;
      }
      return true;
    } else {
      notification.error('Only jpeg,png,jpg,gif formats are allowed');
      // notification.error('Only jpeg,png,jpg,gif formats are allowed')
    }
  };

  const handelFloorPhotos = (index, item) => {
    const check = handleFileUploadSingle(item);
    if (check) {
      setFloorData(
        floorData?.map((res, ind) => {
          if (index === ind) {
            return {
              ...res,
              image: item.target.files[0],
            };
          } else {
            return res;
          }
        }),
      );
    }
  };
  const handleSubCommunitySelect = (e) => {
    const subCommunityId = e.target.value;
    setSelectedSubCommunity(subCommunityId);
    addressChanged({ selectedSubCommunity: subCommunityId });
    // setSelectedSubCommunity(subCommunityId)
  };

  const addressChanged = (options) => {
    if (!isEmpty(options?.selectedSubCommunity)) {
      const locObj = subCommunities.find(
        (c) => c._id === options?.selectedSubCommunity,
      );
      if (!isEmpty(locObj)) {
        const positionObj = Array.from(
          __get(locObj, 'location.coordinates'),
        ).reverse();
        if (!options?.update) {
          setMarkerPosition({ lat: positionObj[0], lng: positionObj[1] });
          setCenter({ lat: positionObj[0], lng: positionObj[1] });
          setValue('latitude', positionObj[0]);
          setValue('longitude', positionObj[1]);
        }
        setSubCommunity(locObj.name);
      }
    } else if (!isEmpty(options?.selectedCommunity)) {
      const locObj = communities.find(
        (c) => c._id === options?.selectedCommunity,
      );
      if (!isEmpty(locObj)) {
        const positionObj = Array.from(
          __get(locObj, 'location.coordinates'),
        ).reverse();
        if (!options?.update) {
          setMarkerPosition({ lat: positionObj[0], lng: positionObj[1] });
          setCenter({ lat: positionObj[0], lng: positionObj[1] });
          setValue('latitude', positionObj[0]);
          setValue('longitude', positionObj[1]);
        }
        setCommunity(locObj.name);
      }
    } else if (!isEmpty(options?.selectedCity)) {
      const locObj = cities.find((c) => c._id === options?.selectedCity);
      if (!isEmpty(locObj)) {
        const positionObj = Array.from(
          __get(locObj, 'location.coordinates'),
        ).reverse();
        if (!options?.update) {
          setMarkerPosition({ lat: positionObj[0], lng: positionObj[1] });
          setCenter({ lat: positionObj[0], lng: positionObj[1] });
          setValue('latitude', positionObj[0]);
          setValue('longitude', positionObj[1]);
        }
        setCity(locObj.name);
      }
    } else if (!isEmpty(options?.latitude) || !isEmpty(options?.longitude)) {
      setMarkerPosition({
        lat: parseFloat(options?.latitude),
        lng: parseFloat(options?.longitude),
      });
      setCenter({
        lat: parseFloat(options?.latitude),
        lng: parseFloat(options?.longitude),
      });
    }
  };
  useEffect(() => {
    setDeleteIcon();
    // eslint-disable-next-line
  }, [photos]);

  const deleteMore = (type, index, img) => {
    switch (type) {
      case 'percentage':
        setPaymentPercent(
          paymentPercent.filter((percentage, tempIndex) => tempIndex !== index),
        );
        break;
      case 'floorPlan':
        if (typeof img !== 'object') {
          const dbUrl = img?.split(config?.country === 'Saudi' ? 'o/' : 'net/');
          setDeletedFloorPlan((prev) => [...prev, dbUrl[1]]);
        }
        setFloorData(
          floorData.filter((percentage, tempIndex) => tempIndex !== index),
        );
        break;
      case 'nearestFacilityAppAr':
        setNearestFacilityAppAr(
          nearestFacilityAppAr.filter(
            (percentage, tempIndex) => tempIndex !== index,
          ),
        );
        break;
      case 'nearestFacilityApp':
        setNearestFacilityApp(
          nearestFacilityApp.filter(
            (percentage, tempIndex) => tempIndex !== index,
          ),
        );
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (editProperty) {
      setEditProperty(editProperty);
    }
  }, [selectedCity, selectedCommunity, selectedSubCommunity, isShowModal]);

  const latitude = watch('latitude');
  const longitude = watch('longitude');

  useEffect(() => {
    addressChanged({
      latitude,
      longitude,
    });
  }, [latitude, longitude]);

  const dragItem = useRef();
  const dragOverItem = useRef();

  const dragStart = (photosType, e, position) => {
    dragItem.current = position;
  };

  const dragEnter = (photosType, index) => {
    if (photosType === 'project') {
      dragOverItem.current = index;
    } else if (photosType === 'artGallary') {
      dragOverItem.current = index;
    }
  };

  const drop = (photosType, index, e) => {
    let copyListItems = [];
    if (photosType === 'project') {
      copyListItems = [...photos];
    } else if (photosType === 'artGallary') {
      copyListItems = Array.isArray(galleryPhotos) ? [...galleryPhotos] : [];
    }
    const dragItemContent = copyListItems[index];
    copyListItems.splice(index, 1);
    copyListItems.splice(dragOverItem.current, 0, dragItemContent);
    dragItem.current = null;
    dragOverItem.current = null;
    if (photosType === 'project') {
      setPhotos(copyListItems);
    } else if (photosType === 'artGallary') {
      setGalleryPhotos(copyListItems);
    }
  };

  let srcValue =
    developerImage !== ''
      ? URL.createObjectURL(developerImage)
      : editProperty?.developerImage || defaultDeveloperImage;

  //const showProjectTypeDropDown = watch("projectStatus") === "ready" ? true : false;
  const showProjectTypeDropDown = true;
  const validatePdfUpload = (e) => {
    const supportedTypes = ['application/pdf'];

    if (!isEmpty(supportedTypes.includes(e?.target?.files[0]?.type))) {
      notification.error('Only pdf files are supported.');
      return false;
    }

    return true;
  };

  const handleWafiFiles = (type = '', e) => {
    if (type === 'image') {
      const isValid = handleFileUploadSingle(e);

      if (!isValid) {
        return;
      }

      setWafiFiles((prev) => {
        return {
          ...prev,
          logo: e.target.files[0],
        };
      });

      return;
    }

    if (type === 'pdf') {
      const isValid = validatePdfUpload(e);

      if (!isValid) {
        return;
      }

      setWafiFiles((prev) => {
        return {
          ...prev,
          contract: e?.target?.files[0],
          contractName: e?.target?.files[0]?.name,
        };
      });
    }
  };

  const handleDeleteWafiFiles = (type = '') => {
    if (type === 'image') {
      setWafiFiles((prev) => {
        return {
          ...prev,
          logo: null,
        };
      });
    }

    if (type === 'pdf') {
      setWafiFiles((prev) => {
        return {
          ...prev,
          contract: null,
          contractName: null,
        };
      });
    }
  };

  function isValidLatitude(lat) {
    const num = parseFloat(lat);
    return !isNaN(num) && num >= -90 && num <= 90;
  }

  function isValidLongitude(lng) {
    const num = parseFloat(lng);
    return !isNaN(num) && num >= -180 && num <= 180;
  }

  async function handleDeleteAttachment(type) {
    if (window.confirm('Are you sure you want to delete this attachment?')) {
      const { data: response } = await apiPut(
        `${apiPath.projectPath}/${editProperty?._id}/delete-attachment`,
        {
          type: type,
        },
      );
      if (response?.success) {
        notification.success(response?.message);
        // After successful deletion, refresh the editProperty by fetching the latest property details
        setEditProperty({
          ...editProperty,
          [type]: null,
        });
      } else {
        notification.error(response?.message);
      }
    }
  }

  console.log(editProperty);

  return (
    <>
      <div className='basic_info px-4 '>
        <form
          className='py-4'
          onSubmit={handleSubmit(handleSubmitForm, () => {
            checkValidation();
          })}>
          <div className='grid grid-rows-1 grid-cols-1 gap-4 mb-3'>
            <Autocomplete
              multiple
              disableCloseOnSelect
              id='project-freelancer-agents'
              options={freelancerAgents}
              getOptionLabel={(option) =>
                `${option?.firstName ?? ''} ${option?.lastName ?? ''}`.trim() ||
                option?.brn ||
                ''
              }
              isOptionEqualToValue={(option, value) =>
                String(option._id) === String(value._id)
              }
              value={selectedAgents}
              onChange={(event, newValue) => {
                setSelectedAgents(newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label='Agents (Freelancer)'
                  placeholder='Select agents'
                  size='small'
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: 'rgb(249 250 251)',
                    },
                  }}
                />
              )}
            />
          </div>
          <div className='py-3 mb-1'>
            <div className='my-2 flex'>
              <div className='mr-4'>
                <h4 className='text-lg'>{t('PROPERTY_CATEGORY')}</h4>
                <span
                  className='bg-[#8FC150] cursor-pointer text-sm block px-4 mr-2  my-2  py-3 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] sm:w-auto w-1/2'
                  onClick={() => setIsPropertyCategories(true)}>
                  {t('SELECT_PROPERTY_CATEGORIES')}
                </span>
                {propertyCategoryType.length !== 0 && (
                  <>
                    (<span className='pr-1'>{propertyCategoryType.length}</span>{' '}
                    <span className=''>{t('SELECTED')}</span>)
                  </>
                )}
                {isPropertyCategory && (
                  <span className='block mt-3'>
                    <ErrorMessage message={isPropertyCategory} />
                  </span>
                )}
              </div>
              <div className='mr-4'>
                <h4 className='text-lg'>{t('AMENITIES')}</h4>
                <span
                  className='bg-[#8FC150] cursor-pointer block text-sm px-4 mr-2  my-2 py-3 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] sm:w-auto w-1/2'
                  onClick={() => setIsAmenities(true)}>
                  {t('SELECT_AMENITIES')}
                </span>
                {propertyAmenities.length !== 0 && (
                  <>
                    (<span className='pr-1'>{propertyAmenities.length}</span>{' '}
                    <span className=''>{t('SELECTED')}</span>)
                  </>
                )}
                {isAmenity && (
                  <span className='block mt-3'>
                    <ErrorMessage message={isAmenity} />
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className=''>
            <div className='grid grid-rows-1 grid-cols-2 gap-4'>
              <div className='mb-3'>
                <label className='block'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='title'
                    inputLabel={
                      <>
                        {t('O_TITLE')}
                        <span className='text-red-500'>*</span>
                      </>
                    }
                    type='text'
                    register={register('title', {
                      required: 'Please enter title.',
                      minLength: {
                        value: 2,
                        message: 'Minimum length must be 2.',
                      },
                      validate: (value) => {
                        return value.trim()
                          ? true
                          : 'White spaces not allowed.';
                      },
                    })}
                    errors={errors}
                  />
                </label>
              </div>
              <div className='mb-3'>
                <label className='block'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='titleAr'
                    inputLabel={
                      <>
                        {t('O_TITLE') + t('O_ARABIC')}
                        <span className='text-red-500'>*</span>
                      </>
                    }
                    type='text'
                    register={register('titleAr', {
                      required: 'Please enter title in arabic.',
                      minLength: {
                        value: 2,
                        message: 'Minimum length must be 2.',
                      },
                      validate: (value) => {
                        return value.trim()
                          ? true
                          : 'White spaces not allowed.';
                      },
                    })}
                    errors={errors}
                  />
                </label>
              </div>
            </div>

            <div className='grid grid-rows-1 grid-cols-2 gap-4'>
              <div className='mb-3'>
                <label className='block'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='sub_title'
                    inputLabel={<>{t('O_SUBTITLE')}</>}
                    type='text'
                    register={register('sub_title')}
                    errors={errors}
                  />
                </label>
              </div>
              <div className='mb-3'>
                <label className='block'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='sub_titleAr'
                    inputLabel={<>{t('O_SUBTITLE') + t('O_ARABIC')}</>}
                    type='text'
                    register={register('sub_titleAr')}
                    errors={errors}
                  />
                </label>
              </div>
            </div>

            <div className='grid grid-rows-1 grid-cols-6 gap-4'>
              <div className='mb-3 '>
                <label className='block'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='startingPrice'
                    inputLabel={
                      <>
                        {t('O_STARTING_PRICE')} ({config?.currency})
                        <span className='text-red-500'>*</span>
                      </>
                    }
                    type='number'
                    register={register('startingPrice', {
                      required: 'Please enter starting price.',
                    })}
                    errors={errors}
                  />
                </label>
              </div>

              <div className='mb-3 '>
                <label className='block'>
                  <div className='relative z-0 w-full group'>
                    <ODatePicker
                      name='handOverDate'
                      placeholder={t('DELIVERY_DATE')}
                      handleDateChange={handleDateChange}
                      value={deliveryDate}
                      inputLabel={<>{t('DELIVERY_DATE')}</>}
                      startDate={new Date()}
                    />
                  </div>
                </label>
              </div>
              <div className='mb-3 '>
                <OSelect
                  wrapperClassName='relative z-0  w-full group'
                  name='projectStatus'
                  inputLabel={
                    <>
                      {t('SELECT_PROJECT_STATUS')}
                      <span className='text-red-500'>*</span>
                    </>
                  }
                  type='select'
                  // selected={editProperty?.projectStatus ?? ''}
                  options={statusOption}
                  defaultValue={t('SELECT_PROJECT_STATUS')}
                  selected={selectedProjectStatus}
                  register={register(
                    'projectStatus',
                    formValidation.projectStatus,
                  )}
                  errors={errors}
                />
              </div>
              <div className='mb-3 '>
                <OSelect
                  wrapperClassName='relative z-0  w-full group'
                  name='constructionStatus'
                  inputLabel={<>{t('CONSTRUCTION_STATUS')}</>}
                  type='select'
                  placeholder={t('SELECT_CONSTRUCTION_STATUS')}
                  options={constructionStatusOptions}
                  selected={selectedConstructionStatus}
                  register={register('constructionStatus')}
                  errors={errors}
                />
              </div>
              {showProjectTypeDropDown && (
                <div className='mb-3 '>
                  <OSelect
                    wrapperClassName='relative z-0  w-full group'
                    name='projectType'
                    inputLabel={
                      <>
                        {t('SELECT_PROJECT_TYPE')}
                        <span className='text-red-500'>*</span>
                      </>
                    }
                    type='select'
                    // selected={editProperty?.projectStatus ?? ''}
                    options={typeOption}
                    defaultValue={t('SELECT_PROJECT_TYPE')}
                    selected={selectedProjectType}
                    register={register(
                      'projectType',
                      formValidation.projectType,
                    )}
                    errors={errors}
                  />
                </div>
              )}

              <div className='mb-3 '>
                <label className='block'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='pricePerSqFt'
                    inputLabel={
                      <>
                        {t('PRICE_PER_SQFT')}
                        {/* <span className='text-red-500'>*</span> */}
                      </>
                    }
                    type='number'
                    register={register('pricePerSqFt', {})}
                    errors={errors}
                  />
                </label>
              </div>
              <div className='mb-3 '>
                <label className='block'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='developerName'
                    inputLabel={
                      <>
                        {t('DEVELOPER_NAME')}
                        <span className='text-red-500'>*</span>
                      </>
                    }
                    type='text'
                    register={register('developerName', {
                      required: 'Please enter developer name.',
                      // pattern: {
                      //   value: /^[a-zA-Z]+$/,
                      //   message: 'Invalid developer name.'
                      // },
                      // minLength: {
                      //   value: 2,
                      //   message:
                      //     'Developer name should contain at least 2 characters.'
                      // },
                      // validate: value => {
                      //   return value.trim() ? true : 'White spaces not allowed.'
                      // }
                    })}
                    errors={errors}
                  />
                </label>
              </div>
              <div className='mb-3 '>
                <label className='block'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='developerNameAr'
                    inputLabel={
                      <>
                        {t('DEVELOPER_NAME') + t('O_ARABIC')}
                        <span className='text-red-500'>*</span>
                      </>
                    }
                    type='text'
                    register={register('developerNameAr', {
                      required: 'Please enter developer name in arabic.',
                      minLength: {
                        value: 2,
                        message:
                          'Developer name(arabic) should contain at least 2 characters.',
                      },
                      validate: (value) => {
                        return value.trim()
                          ? true
                          : 'White spaces not allowed.';
                      },
                    })}
                    errors={errors}
                  />
                </label>
              </div>
              <div className='mb-3 '>
                <label className='block'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='metaTitle'
                    inputLabel={
                      <>
                        {t('STATIC_TITLE')}
                        {/* <span className='text-red-500'>*</span> */}
                      </>
                    }
                    type='text'
                    register={register('metaTitle', {
                      // required: 'Please enter meta title.'
                    })}
                    errors={errors}
                  />
                </label>
              </div>
              <div className='mb-3 '>
                <label className='block'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='metaTitleAr'
                    inputLabel={
                      <>
                        {t('STATIC_TITLE')} {t('O_ARABIC')}
                        {/* <span className='text-red-500'>*</span> */}
                      </>
                    }
                    type='text'
                    register={register('metaTitleAr', {
                      // required: 'Please enter meta title in arabic.'
                    })}
                    errors={errors}
                  />
                </label>
              </div>
              <div className='mb-3 '>
                <label className='block'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='metaDescription'
                    inputLabel={<>{t('STATIC_DESCRIPTION')}</>}
                    type='text'
                    register={register('metaDescription', {})}
                    errors={errors}
                  />
                </label>
              </div>
              <div className='mb-3 '>
                <label className='block'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='metaDescriptionAr'
                    inputLabel={
                      <>
                        {t('STATIC_DESCRIPTION')} {t('O_ARABIC')}
                        {/* <span className='text-red-500'>*</span> */}
                      </>
                    }
                    type='text'
                    register={register('metaDescriptionAr', {
                      // required: 'Please enter meta description in arabic.'
                    })}
                    errors={errors}
                  />
                </label>
              </div>
              <div className='mb-3 '>
                <label className='block'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='keyword'
                    inputLabel={
                      <>
                        {t('KEYWORD')}
                        {/* <span className='text-red-500'>*</span> */}
                      </>
                    }
                    type='text'
                    register={register('keyword', {
                      // required: 'Please enter keyword.'
                    })}
                    errors={errors}
                  />
                </label>
              </div>
              <div className='mb-3 '>
                <label className='block'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='keywordAr'
                    inputLabel={
                      <>
                        {t('KEYWORD')} {t('O_ARABIC')}
                        {/* <span className='text-red-500'>*</span> */}
                      </>
                    }
                    type='text'
                    register={register('keywordAr', {
                      // required: 'Please enter keyword in arabic.'
                    })}
                    errors={errors}
                  />
                </label>
              </div>
            </div>
            {banks?.length ? (
              <div className='grid grid-rows-1 grid-cols-1 gap-4'>
                <Select
                  label='Bank'
                  name='bankId'
                  value={selectedBank}
                  onChange={(e) => {
                    setSelectedBank(e.target.value);
                  }}>
                  {banks.map((bank) => {
                    return (
                      <option key={bank._id} value={bank._id}>
                        {bank.bankName} - {bank.accountName}
                      </option>
                    );
                  })}
                </Select>
              </div>
            ) : null}
            {editProperty?.slug && (
              <div className='grid grid-rows-1 grid-cols-2 gap-4'>
                <div className='mb-3'>
                  <label className='block'>
                    <OInputField
                      wrapperClassName='relative z-0   w-full group'
                      name='slug'
                      inputLabel={
                        <>
                          {t('O_SLUG')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='text'
                      register={register('slug', formValidation.slug)}
                      errors={errors}
                    />
                  </label>
                </div>
                <div className='mb-3'>
                  <label className='block'>
                    <OInputField
                      wrapperClassName='relative z-0   w-full group'
                      name='slugAr'
                      inputLabel={
                        <>
                          {t('O_SLUG') + t('O_ARABIC')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='text'
                      register={register('slugAr', formValidation.slugAr)}
                      errors={errors}
                    />
                  </label>
                </div>
              </div>
            )}

            <h4 className='text-lg font-semibold py-3'>
              {t('PAYMENT_PERCENTAGE')}
            </h4>
            {paymentPercent?.length > 0 &&
              paymentPercent?.map((item, index) => {
                return (
                  <div
                    className='flex gap-4 xl:gap-12  w-auto inline-block px-3 mb-2 rounded-sm'
                    key={index}>
                    <div className='py-3 mb-1 flex-0 w-1/2 xl:w-1/3'>
                      <label className='block'>
                        <span className='block text-sm font-medium mb-2'>
                          {t('O_TITLE')}
                        </span>
                        <input
                          type='text'
                          name='paymentTitle'
                          className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                          // placeholder={t('O_TITLE')}
                          value={item?.paymentTitle}
                          onChange={(e) => {
                            setPaymentPercent(
                              paymentPercent?.map((res, ind) => {
                                if (ind === index) {
                                  return {
                                    ...res,
                                    paymentTitle: e.target.value,
                                  };
                                } else {
                                  return res;
                                }
                              }),
                            );
                          }}
                        />
                      </label>
                    </div>
                    <div className='py-3 mb-1 flex-0 w-1/2 xl:w-1/3'>
                      <label className='block'>
                        <span className='block text-sm font-medium mb-2'>
                          {t('O_TITLE') + t('O_ARABIC')}
                        </span>
                        <input
                          type='text'
                          name='paymentTitleAr'
                          className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                          // placeholder={t('O_TITLE')}
                          value={item?.paymentTitleAr}
                          onChange={(e) => {
                            setPaymentPercent(
                              paymentPercent?.map((res, ind) => {
                                if (ind === index) {
                                  return {
                                    ...res,
                                    paymentTitleAr: e.target.value,
                                  };
                                } else {
                                  return res;
                                }
                              }),
                            );
                          }}
                        />
                      </label>
                    </div>
                    <div className='py-3 mb-1 flex-0 w-1/2 xl:w-1/3'>
                      <label className='block'>
                        <span className='block text-sm font-medium mb-1'>
                          {t('PERCENTAGE')}
                        </span>
                        <div className='flex justify-between items-center'>
                          <input
                            type='number'
                            name='percentage'
                            className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                            placeholder={t('PERCENTAGE')}
                            value={item?.percentage}
                            onChange={(e) => {
                              setPaymentPercent(
                                paymentPercent?.map((res, ind) => {
                                  if (ind === index) {
                                    return {
                                      ...res,
                                      percentage: e.target.value,
                                    };
                                  } else {
                                    return res;
                                  }
                                }),
                              );
                            }}
                          />
                          <button
                            type='button'
                            className='ml-3  text-black rounded-full text-xxl leading-none font-extralight outline-none focus:outline-none   bg-blue-200 w-[45px] h-[40px]'
                            onClick={() => deleteMore('percentage', index)}>
                            <span
                              className=' text-[#222]  text-lg '
                              title='Close'>
                              ×
                            </span>
                          </button>
                        </div>
                      </label>
                    </div>
                  </div>
                );
              })}
            <button
              className='text-blue-400'
              type='button'
              onClick={addMorePaymentPercentage}>
              {t('ADD_MORE')}
            </button>

            <h4 className='text-lg font-semibold py-3 mt-3'>
              {t('BANK_DETAILS')}
            </h4>
            <div className='grid grid-rows-1 grid-cols-2 gap-4'>
              <div className='mb-3 '>
                <label className='block'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='accountName'
                    inputLabel={<>{t('ACCOUNT_NAME')}</>}
                    type='text'
                    register={register('accountName')}
                    errors={errors}
                  />
                </label>
              </div>
              <div className='mb-3 '>
                <label className='block'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='accountNameAr'
                    inputLabel={<>{t('ACCOUNT_NAME') + t('O_ARABIC')}</>}
                    type='text'
                    register={register('accountNameAr')}
                    errors={errors}
                  />
                </label>
              </div>
              <div className='mb-3 '>
                <label className='block'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='bankName'
                    inputLabel={<>{t('BANK_NAME')}</>}
                    type='text'
                    register={register('bankName')}
                    errors={errors}
                  />
                </label>
              </div>
              <div className='mb-3 '>
                <label className='block'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='bankNameAr'
                    inputLabel={<>{t('BANK_NAME') + t('O_ARABIC')}</>}
                    type='text'
                    register={register('bankNameAr')}
                    errors={errors}
                  />
                </label>
              </div>
              <div className='mb-3 '>
                <label className='block'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='iban'
                    inputLabel={<>{t('IBAN')}</>}
                    type='text'
                    register={register('iban')}
                    errors={errors}
                  />
                </label>
              </div>
              <div className='mb-3 '>
                <label className='block'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='downPaymentPercentage'
                    inputLabel={<>{t('DOWN_PAYMENT_PERCENTAGE')}</>}
                    type='text'
                    register={register('downPaymentPercentage', {
                      pattern: {
                        value: /^\d*\.?\d*$/,
                        message:
                          'Only numbers and one decimal point are allowed',
                      },
                      setValueAs: (value) =>
                        value === '' ? undefined : parseFloat(value), // convert to number
                    })}
                    errors={errors}
                  />
                </label>
              </div>
            </div>

            <div className='grid grid-cols-3 gap-2 mt-5 border bottom-1 p-8 px-4 rounded-md'>
              <div className='mb-3 border p-3'>
                <label className='mb-2 block'>{t('BEDROOMS')}</label>
                <div className='grid grid-cols-2 gap-5'>
                  <OInputField
                    wrapperClassName='relative z-0 group w-full'
                    name='minBedrooms'
                    inputLabel={
                      <>
                        {t('MIN')}
                        {/* <span className='text-red-500'>*</span> */}
                      </>
                    }
                    type='number'
                    register={register(
                      'minBedrooms',
                      // formValidation.minBedrooms
                    )}
                    errors={errors}
                  />
                  <OInputField
                    wrapperClassName='relative z-0 group w-full'
                    name='maxBedrooms'
                    inputLabel={
                      <>
                        {t('MAX')}
                        {/* <span className='text-red-500'>*</span> */}
                      </>
                    }
                    type='number'
                    register={register('maxBedrooms', {})}
                    errors={errors}
                  />
                </div>
              </div>
              <div className='mb-3 border p-3'>
                <label className='mb-2 block'>{t('BATHROOMS')}</label>
                <div className='grid grid-cols-2 gap-5'>
                  <OInputField
                    wrapperClassName='relative z-0 group w-full'
                    name='minBathrooms'
                    inputLabel={
                      <>
                        {t('MIN')}
                        {/* <span className='text-red-500'>*</span> */}
                      </>
                    }
                    type='number'
                    register={register(
                      'minBathrooms',
                      // formValidation.minBathrooms
                    )}
                    errors={errors}
                  />
                  <OInputField
                    wrapperClassName='relative z-0 group w-full'
                    name='maxBathrooms'
                    inputLabel={
                      <>
                        {t('MAX')}
                        {/* <span className='text-red-500'>*</span> */}
                      </>
                    }
                    type='number'
                    register={register('maxBathrooms', {})}
                    errors={errors}
                  />
                </div>
              </div>
              <div className='mb-3  border p-4'>
                <label className='mb-2 block'>{t('LIVING_ROOMS')}</label>
                <div className='grid grid-cols-2 gap-5'>
                  <OInputField
                    wrapperClassName='relative z-0 group w-full'
                    name='minLivingRooms'
                    inputLabel={
                      <>
                        {t('MIN')}
                        {/* <span className='text-red-500'>*</span> */}
                      </>
                    }
                    type='number'
                    register={register(
                      'minLivingRooms',
                      // formValidation.minLivingRooms,
                      // {
                      //   validate: val =>
                      //     parseInt(val) > 0
                      //       ? true
                      //       : 'Value must be greater than 0.'
                      // }
                    )}
                    errors={errors}
                  />
                  <OInputField
                    wrapperClassName='relative z-0 group w-full'
                    name='maxLivingRooms'
                    inputLabel={
                      <>
                        {t('MAX')}
                        {/* <span className='text-red-500'>*</span> */}
                      </>
                    }
                    type='number'
                    register={register('maxLivingRooms', {})}
                    errors={errors}
                  />
                </div>
              </div>
              <div className=' mb-3 border p-3'>
                <label className='mb-2 block'>{t('GUEST_ROOMS')}</label>
                <div className='grid grid-cols-2 gap-5'>
                  <OInputField
                    wrapperClassName='relative z-0 group w-full'
                    name='minGuestRooms'
                    inputLabel={
                      <>
                        {t('MIN')}
                        {/* <span className='text-red-500'>*</span> */}
                      </>
                    }
                    type='number'
                    register={register(
                      'minGuestRooms',
                      // formValidation.minGuestRooms
                      {
                        validate: (val) => {
                          if (
                            parseInt(val) >= parseInt(watch('maxGuestRooms'))
                          ) {
                            return 'please enter less than minimum guest rooms.';
                          } else if (parseInt(val) <= 0) {
                            return 'value must be greater than 0.';
                          }
                        },
                      },
                    )}
                    errors={errors}
                  />
                  <OInputField
                    wrapperClassName='relative z-0 group w-full'
                    name='maxGuestRooms'
                    inputLabel={
                      <>
                        {t('MAX')}
                        {/* <span className='text-red-500'>*</span> */}
                      </>
                    }
                    type='number'
                    register={register('maxGuestRooms', {
                      // required: 'Please enter max guest rooms.'
                      validate: (val) => {
                        if (parseInt(val) <= parseInt(watch('minGuestRooms'))) {
                          return 'please enter greater than minimum guest rooms.';
                        }
                      },
                    })}
                    errors={errors}
                  />
                </div>
              </div>
              <div className=' mb-3 border p-3'>
                <label className='mb-2 block'>
                  {t('O_PROPERTY_SIZE')}
                  {` (${config?.areaUnit}) `}
                </label>
                <div className='grid grid-cols-2 gap-5'>
                  <OInputField
                    wrapperClassName='relative z-0 group w-full'
                    name='minPropertySize'
                    inputLabel={
                      <>
                        {t('MIN')}
                        <span className='text-red-500'>*</span>
                      </>
                    }
                    type='number'
                    register={register(
                      'minPropertySize',
                      formValidation.minPropertySize,
                    )}
                    errors={errors}
                  />
                  <OInputField
                    wrapperClassName='relative z-0 group w-full'
                    name='maxPropertySize'
                    inputLabel={
                      <>
                        {t('MAX')}
                        {/* <span className='text-red-500'>*</span> */}
                      </>
                    }
                    type='number'
                    register={register('maxPropertySize', {})}
                    errors={errors}
                  />
                </div>
              </div>
            </div>
            <div className='py-3 mb-1 max-w-md'>
              <div className='flex gap-4'>
                <label className='block w-full'>
                  <span className='block text-sm font-medium '>
                    {t('ADD_VIDEO_URL')}
                  </span>
                  <div className='flex border rounded-md overflow-hidden mt-1'>
                    <span
                      className=' px-3 cursor-pointer py-3 bg-white border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full sm:text-sm focus:ring-1'
                      // onClick={() => videoRef?.current?.click()}
                    >
                      {t('UPLOAD_VIDEO')}
                    </span>
                    <input
                      type='file'
                      name='video'
                      accept='video/mp4, video/x-matroska, .mkv'
                      // ref={videoRef}
                      onChange={(e) => handleChange(e)}
                      onClick={(e) => (e.target.value = null)}
                      multiple
                      className='hidden'
                    />
                    <span
                      className='flex items-center justify-center bg-lime-500 text-white text-sm rounded-r w-[84px]'
                      // onClick={() => videoRef?.current?.click()}
                    >
                      Upload
                    </span>
                  </div>
                </label>
                {editProperty?.profilePicture && (
                  <div className='flex items-center justify-center gap-2'>
                    <a
                      href={editProperty?.profilePicture}
                      target='_blank'
                      rel='noopener noreferrer'
                      className='flex items-center justify-center text-lime-500'>
                      <BsEye />
                    </a>
                    <button
                      type='button'
                      className='flex items-center justify-center text-red-500'
                      onClick={() => handleDeleteAttachment('profilePicture')}>
                      <BiTrash />
                    </button>
                  </div>
                )}
              </div>
              <div className='flex justify-between mt-5'>
                {createVideoUrl?.length > 0 &&
                  createVideoUrl?.map((item, index) => (
                    <div
                      key={index}
                      className='w-[164px] h-[164px] xl:w-[204px] xl:h-[204px] rounded border-2 relative overflow-hidden p-2'>
                      <video
                        className='w-full h-full m-auto object-cover'
                        controls
                        width='320'
                        height='240'
                        src={
                          // typeof item === 'string'
                          //   ?
                          item
                          // : URL.createObjectURL(item)
                        }
                      />
                      <button
                        type='button'
                        className='absolute top-[10px] right-[10px]'
                        onClick={() => removeVideo(item)}>
                        <img src={photoClose} alt='' />
                      </button>
                    </div>
                  ))}
              </div>
            </div>
            <div className='mb-3'>
              <div className='flex justify-between items-center my-2'>
                <div>
                  <h4 className='text-lg font-semibold pt-3'>
                    {t('UPLOAD_CONSTRUCTION_PHOTOS_AND_VIDEOS')}
                  </h4>
                </div>
              </div>
              <div className='photo_list flex flex-wrap gap-5'>
                <div
                  className='p-3 w-[164px] xl:w-[204px] h-[204px] border-dashed rounded-md border flex items-center justify-center cursor-pointer'
                  onClick={() => constructionAssetsRef?.current?.click()}>
                  <div className='text-center'>
                    <img
                      src='../images/uploadimg.png'
                      className='m-auto'
                      alt=''
                    />
                    <strong className='my-2 block text-xl'>
                      {t('ADD_PHOTO_AND_VIDEOS')}
                    </strong>
                    <span className='block text-sm font-medium px-1'>
                      {`${t(
                        'UPLOAD_CONSTRUCTION_PHOTOS_AND_VIDEOS',
                      )} (max ${MAX_CONSTRUCTION_ASSETS})`}
                    </span>
                    <input
                      type='file'
                      name='constructionAssets'
                      ref={constructionAssetsRef}
                      accept='image/png, image/jpg, image/jpeg, image/gif, image/webp, video/mp4, video/quicktime, video/x-msvideo, video/x-ms-wmv, video/webm, video/x-matroska, .mkv'
                      onChange={(e) => handleConstructionAssetsChange(e)}
                      onClick={(e) => {
                        e.target.value = null;
                      }}
                      className='hidden'
                      multiple
                    />
                  </div>
                </div>
                {createConstructionAssets?.length > 0 &&
                  createConstructionAssets?.map((previewSrc, index) => {
                    const fileEntry = constructionAssetsFiles[index];
                    const showVideo = isConstructionEntryVideo(
                      fileEntry,
                      previewSrc,
                    );
                    return (
                      <div
                        key={index}
                        className='w-[164px] h-[164px] xl:w-[204px] xl:h-[204px] rounded border-2 relative overflow-hidden p-2'>
                        {showVideo ? (
                          <video
                            className='w-full h-full m-auto object-cover'
                            controls
                            width='320'
                            height='240'
                            src={previewSrc}
                          />
                        ) : (
                          <figure className='w-full h-full'>
                            <OImage
                              src={previewSrc}
                              fallbackUrl='/images/user.png'
                              className='w-full h-full object-cover'
                              alt=''
                            />
                          </figure>
                        )}
                        <button
                          type='button'
                          className='absolute top-[10px] right-[10px]'
                          onClick={() => removeConstructionAssetAt(index)}>
                          <img src={photoClose} alt='' />
                        </button>
                      </div>
                    );
                  })}
              </div>
            </div>
            <div className='mb-3'>
              <div className='flex justify-between items-center my-2'>
                <div>
                  <h4 className='text-lg font-semibold pt-3'>
                    {t('UPLOAD_INFOGRAPHY')}
                  </h4>
                </div>
              </div>
              <div className='photo_list flex flex-wrap gap-5'>
                <div
                  className='p-3 w-[164px] xl:w-[204px] h-[204px] border-dashed rounded-md border flex items-center justify-center cursor-pointer'
                  onClick={() => infographyRef?.current?.click()}>
                  <div className='text-center'>
                    <img
                      src='../images/uploadimg.png'
                      className='m-auto'
                      alt=''
                    />
                    <strong className='my-2 block text-xl'>
                      {t('ADD_INFOGRAPHY')}
                    </strong>
                    <span className='block text-sm font-medium px-1'>
                      {`${t('UPLOAD_INFOGRAPHY')} (max ${MAX_INFOGRAPHY})`}
                    </span>
                    <input
                      type='file'
                      name='infography'
                      ref={infographyRef}
                      accept='image/png, image/jpg, image/jpeg, image/gif'
                      onChange={(e) => handleInfographyChange(e)}
                      onClick={(e) => {
                        e.target.value = null;
                      }}
                      className='hidden'
                      multiple
                    />
                  </div>
                </div>
                {createInfography?.length > 0 &&
                  createInfography?.map((previewSrc, index) => (
                    <div
                      key={index}
                      className='w-[164px] h-[164px] xl:w-[204px] xl:h-[204px] rounded border-2 relative overflow-hidden p-2'>
                      <figure className='w-full h-full'>
                        <OImage
                          src={previewSrc}
                          fallbackUrl='/images/user.png'
                          className='w-full h-full object-cover'
                          alt=''
                        />
                      </figure>
                      <button
                        type='button'
                        className='absolute top-[10px] right-[10px]'
                        onClick={() => removeInfographyAt(index)}>
                        <img src={photoClose} alt='' />
                      </button>
                    </div>
                  ))}
              </div>
            </div>
            <div className='flex mt-3'>
              <div className=''>
                <div className='py-4 flex '>
                  <div className='relative'>
                    <label className='block mb-2 cursor-pointer text-sm font-medium text-gray-900 dark:text-white w-30'>
                      <span className='flex align-center'>
                        {t('UPLOAD_DEVELOPER_IMAGE')}
                      </span>
                    </label>
                    <input
                      type='file'
                      accept='image/png, image/jpg, image/jpeg'
                      name='developerImage'
                      ref={developerImageRef}
                      onChange={handleDeveloperImageChange}
                      className='hidden'
                    />

                    <div className='relative'>
                      <OImage
                        src={srcValue}
                        fallbackUrl={defaultDeveloperImage}
                        className='w-24 h-24 m-auto'
                        alt=''
                        style={{ borderRadius: '50%' }}
                      />

                      <AiFillCamera
                        className=' bg-gray-100  absolute w-4 rounded-xl cursor-pointer '
                        style={{
                          width: '1.5rem',
                          height: '1.5rem',
                          bottom: '0',
                          right: '20px',
                          background: '',
                          padding: '1px',
                        }}
                        onClick={() => developerImageRef?.current?.click()}
                      />
                    </div>
                  </div>
                </div>
                <div className='text-center mt-4'>
                  <ErrorMessage message={developerImgError} />
                </div>
              </div>
            </div>

            <div className='mb-3 '>
              <p className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
                {t('OFFERS_DESCRIPTION')}
              </p>
              <div className='shadow-md mb-5 rounded-[4px]  hover:outline-none focus:outline-none hover:border-yellow-500 '>
                <ReactQuill
                  theme='snow'
                  value={description}
                  onChange={setDescription}
                />
              </div>
            </div>
            <div className='mb-3 '>
              <p className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
                {t('OFFERS_DESCRIPTION') + t('O_ARABIC')}
              </p>
              <div className='shadow-md mb-5 rounded-[4px]  hover:outline-none focus:outline-none hover:border-yellow-500 '>
                <ReactQuill
                  theme='snow'
                  value={descriptionAr}
                  onChange={setDescriptionAr}
                />
              </div>
            </div>

            <div className='flex justify-between items-center my-2'>
              <div>
                <h4 className='text-lg font-semibold pt-3'>
                  {t('UPLOAD_PROJECT_PHOTOS')}
                </h4>
                {/* <span className='block text-red-500'>
                  {t(
                    'PHOTOS_MUST_BE_UPLOADED_IN_ORDER_TO_REARRANGE_THE_PHOTOS'
                  )}
                </span> */}
              </div>
            </div>
            <div className='photo_list flex flex-wrap gap-5'>
              <div
                className='p-3 w-[164px]  xl:w-[204px] h-[204px] border-dashed rounded-md border flex items-center justify-center cursor-pointer'
                onClick={() => photosRef?.current?.click()}>
                <div className='text-center'>
                  <img
                    src='../images/uploadimg.png'
                    className='m-auto'
                    alt=''
                  />
                  <strong className='my-2 block text-xl'>
                    {t('ADD_PHOTO')}
                  </strong>
                  <strong className='my-2 block '>
                    {t('(Max size 2 MB)')}
                  </strong>
                  <span className='block text-sm font-medium'>
                    {t('MIN_IMAGE_TEXT')}
                  </span>
                  <input
                    type='file'
                    accept='image/png, image/jpg, image/jpeg'
                    name='image'
                    ref={photosRef}
                    onChange={handlePhotosChange('project')}
                    className='hidden'
                    multiple
                  />
                </div>
              </div>

              {photos?.map((item, index) => (
                <div
                  key={index}
                  onDragStart={(e) => dragStart('project', e, index)}
                  onDragEnter={(e) => dragEnter('project', index, e)}
                  onDragEnd={(e) => drop('project', index, e)}
                  draggable
                  style={{ cursor: 'move' }}
                  className='w-[164px] h-[164px] xl:w-[204px] xl:h-[204px] rounded-md relative overflow-hidden'>
                  <figure className='w-full h-full'>
                    <OImage
                      src={
                        typeof item === 'object'
                          ? URL.createObjectURL(item)
                          : item
                      }
                      fallbackUrl='/images/user.png'
                      className='w-full h-full object-cover'
                      alt=''
                    />
                  </figure>

                  <button
                    type='button'
                    className='absolute top-[10px] right-[10px]'
                    onClick={() => removePhotos('project', item)}>
                    <img src={photoClose} alt='' />
                  </button>
                </div>
              ))}
            </div>
            <hr className='my-4' />
            <div className='flex justify-between items-center my-2'>
              <div>
                <h4 className='text-lg font-semibold pt-3'>
                  {t('UPLOAD_GALLERY_PHOTOS')}
                </h4>
                {/* <span className='block text-red-500'>
                  {t(
                    'PHOTOS_MUST_BE_UPLOADED_IN_ORDER_TO_REARRANGE_THE_PHOTOS'
                  )}
                </span> */}
              </div>
            </div>
            <div className='photo_list flex flex-wrap gap-5'>
              <div
                className='p-3 w-[164px]  xl:w-[204px] h-[204px] border-dashed rounded-md border flex items-center justify-center cursor-pointer'
                onClick={() => galleryPhotosRef?.current?.click()}>
                <div className='text-center'>
                  <img
                    src='../images/uploadimg.png'
                    className='m-auto'
                    alt=''
                  />
                  <strong className='my-2 block text-xl'>
                    {t('ADD_PHOTO')}
                  </strong>
                  <strong className='my-2 block '>
                    {t('(Max size 2 MB)')}
                  </strong>
                  <span className='block text-sm font-medium'>
                    {t('MIN_IMAGE_TEXT')}
                  </span>
                  <input
                    type='file'
                    accept='image/png, image/jpg, image/jpeg'
                    name='image'
                    ref={galleryPhotosRef}
                    onChange={handlePhotosChange('artGallary')}
                    className='hidden'
                    multiple
                  />
                </div>
              </div>

              {galleryPhotos?.map((item, index) => (
                <div
                  key={index}
                  onDragStart={(e) => dragStart('artGallary', e, index)}
                  onDragEnter={(e) => dragEnter('artGallary', index, e)}
                  onDragEnd={(e) => drop('artGallary', index, e)}
                  draggable
                  style={{ cursor: 'move' }}
                  className='w-[164px] h-[164px] xl:w-[204px] xl:h-[204px] rounded-md relative overflow-hidden'>
                  <figure className='w-full h-full'>
                    <OImage
                      src={
                        typeof item === 'object'
                          ? URL.createObjectURL(item)
                          : item
                      }
                      fallbackUrl='/images/user.png'
                      className='w-full h-full object-cover'
                      alt=''
                    />
                  </figure>

                  <button
                    type='button'
                    className='absolute top-[10px] right-[10px]'
                    onClick={() => removePhotos('artGallary', item)}>
                    <img src={photoClose} alt='' />
                  </button>
                </div>
              ))}
            </div>

            <h4 className='text-lg font-semibold py-3'>
              {t('UPLOAD_FLOOR_PLAN_PHOTOS')}
            </h4>

            {floorData?.length > 0 &&
              floorData?.map((item, index) => {
                return (
                  <div className='flex  gap-4 xl:gap-12 ' key={index}>
                    <div className='py-3 mb-1 flex-0 w-1/2 xl:w-1/3'>
                      <label className='block'>
                        <span className='block text-sm font-medium mb-2'>
                          {t('O_TITLE')}
                        </span>
                        <input
                          type='text'
                          name='titleFloorPlan'
                          className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                          placeholder={t('O_TITLE')}
                          value={item?.titleFloorPlan}
                          onChange={(e) => {
                            setFloorData(
                              floorData?.map((res, ind) => {
                                if (ind === index) {
                                  return {
                                    ...res,
                                    titleFloorPlan: e.target.value,
                                  };
                                } else {
                                  return res;
                                }
                              }),
                            );
                          }}
                        />
                      </label>
                    </div>
                    <div className='py-3 mb-1 flex-0 w-1/2 xl:w-1/3'>
                      <label className='block'>
                        <span className='block text-sm font-medium mb-2 text-gray-400'>
                          {t('O_TITLE') + t('O_ARABIC')}
                        </span>
                        <input
                          type='text'
                          name={index}
                          disabled={item?.disabled}
                          className='bg-gray-50 border  border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                          placeholder={t('O_TITLE') + t('O_ARABIC')}
                          value={item?.titleAr}
                          onChange={(e) => {
                            setFloorData(
                              floorData?.map((res, ind) => {
                                if (ind === index) {
                                  return {
                                    ...res,
                                    titleFloorPlanAr: e.target.value,
                                  };
                                } else {
                                  return res;
                                }
                              }),
                            );
                          }}
                        />
                      </label>
                    </div>
                    <div className='py-3 mb-1 flex-0 w-1/2 xl:w-1/3'>
                      <label className='block'>
                        <span className='block text-sm font-medium'>
                          {t('O_SIZE_FLOOR_PLAN')}
                        </span>
                        <div className='flex items-center'>
                          <div className='truncate relative flex border rounded-md overflow-hidden mt-1'>
                            <span className='absolute p-3 pr-9 left-0 right-0 top-auto truncate'>
                              {t('UPLOAD_FLOOR_PLAN_PHOTOS')}
                            </span>
                            <input
                              type='file'
                              placeholder='10.95'
                              onChange={(e) => handelFloorPhotos(index, e)}
                              className='opacity-0 px-3 py-3 bg-transparent relative z-10 border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full sm:text-sm focus:ring-1'
                            />
                            <button className='flex items-center justify-center absolute right-0 top-4 text-white text-sm rounded-r w-[40px] bg-white'>
                              <img src='../images/upload.svg' alt='' />
                            </button>
                          </div>
                          <div className='flex items-center'>
                            {item?.image && (
                              <div className=' ml-3 h-16 w-16 overflow-hidden border-4  rounded-full'>
                                <img
                                  src={
                                    typeof item?.image === 'object'
                                      ? URL.createObjectURL(item?.image)
                                      : item?.image
                                  }
                                  alt=''
                                  className='w-full h-full object-cover'
                                />
                              </div>
                            )}
                            <button
                              type='button'
                              className='ml-3  text-black rounded-full text-xxl leading-none font-extralight outline-none focus:outline-none mt-3  bg-blue-200 w-[40px] h-[40px]'
                              onClick={() =>
                                deleteMore('floorPlan', index, item?.image)
                              }>
                              <span
                                className=' text-[#222]  text-lg '
                                title='Close'>
                                ×
                              </span>
                            </button>
                          </div>
                        </div>
                      </label>
                    </div>
                  </div>
                );
              })}
            <button
              className='text-blue-400'
              type='button'
              onClick={addMoreFloor}>
              {t('ADD_MORE')}
            </button>
            <div className=' overflow-hidden rounded-lg my-5 w-full'>
              <OMapContainer
                addressChanged={addressChanged}
                options={{
                  AREA_BOUND: AREA_BOUND[config.country], // Sample: { north: 26.245017, south: 22.495708, east: 56.611014, west: 51.498994}
                  AREA_REGION: AREA_REGION[config.country], // Sample: { lat: 23.424076, lng: 53.847818}
                  COUNTRY_RESTRICTIONS: COUNTRY_RESTRICTIONS[config.country], // Sample: "AE"
                  ADDRESS: !isEmpty(editProperty) ? editProperty?.address : '',
                  // ...(!isEmpty(editProperty) &&
                  //   editProperty?.location?.coordinates?.length && {
                  //     ...(editProperty?.location?.coordinates[1] && {
                  //       lat: editProperty?.location?.coordinates[1]
                  //     }),
                  //     ...(editProperty?.location?.coordinates[0] && {
                  //       lng: editProperty?.location?.coordinates[0]
                  //     })
                  //   })
                  markerPosition: markerPosition,
                  center: center,
                }}
              />
            </div>
            <form className='py-4'>
              <div className='grid grid-rows-1 grid-cols-3 gap-4'>
                <div className='mb-3 '>
                  <div className='relative z-0  w-full group'>
                    <label
                      htmlFor='cityId'
                      className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
                      {t('SELECT_CITY')}
                      <span className='text-red-500'>*</span>
                    </label>

                    <select
                      className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                      value={selectedCity}
                      id='cityId'
                      {...register('cityId', {
                        required: {
                          value: true,
                          message: 'Please select city..',
                        },
                        onChange: (e) => handleCitySelect(e),
                      })}
                      placeholder=' '>
                      <option value=''>{t('SELECT_CITY')}</option>
                      {cities.map((newCity) => (
                        <option key={newCity?._id} value={newCity?._id}>
                          {newCity?.name}
                        </option>
                      ))}
                    </select>
                    <ErrorMessage message={errors?.cityId?.message} />
                  </div>
                </div>

                <div className='mb-3 '>
                  <div className='relative z-0  w-full group'>
                    <label
                      htmlFor='communityId'
                      className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
                      {t('SELECT_COMMUNITY')}
                      <span className='text-red-500'>*</span>
                    </label>

                    <select
                      className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                      value={selectedCommunity}
                      id='communityId'
                      {...register('communityId', {
                        required: {
                          value: true,
                          message: 'Select Community.',
                        },
                        onChange: (e) => handleCommunitySelect(e),
                      })}
                      placeholder=' '>
                      <option value=''>{t('SELECT_COMMUNITY')}</option>
                      {communities.map((newCommunity) => (
                        <option
                          key={newCommunity?._id}
                          value={newCommunity?._id}>
                          {newCommunity?.name}
                        </option>
                      ))}
                    </select>
                    <ErrorMessage message={errors?.communityId?.message} />
                  </div>
                </div>

                <div className='mb-3 '>
                  <div className='relative z-0  w-full group'>
                    <label
                      htmlFor='subCommunityId'
                      className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
                      {t('SELECT_SUB_COMMUNITY')}
                      {/* <span className='text-red-500'>*</span> */}
                    </label>

                    <select
                      className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                      value={selectedSubCommunity}
                      id='subCommunityId'
                      {...register('subCommunityId', {
                        onChange: (e) => handleSubCommunitySelect(e),
                      })}
                      placeholder=' '>
                      <option value=''>{t('SELECT_SUB_COMMUNITY')}</option>
                      {subCommunities.map((newSubCommunity) => (
                        <option
                          key={newSubCommunity?._id}
                          value={newSubCommunity?._id}>
                          {newSubCommunity?.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className='mb-3'>
                  <label className='block'>
                    <OInputField
                      wrapperClassName='relative z-0   w-full group'
                      name='building'
                      inputLabel={
                        <>
                          {t('BUILDING')}
                          {/* <span className='text-red-500'>*</span> */}
                        </>
                      }
                      type='text'
                      register={register(
                        'building',
                        //  formValidation.building
                      )}
                      errors={errors}
                    />
                  </label>
                </div>
                <div className='mb-3'>
                  <label className='block'>
                    <OInputField
                      wrapperClassName='relative z-0   w-full group'
                      name='buildingAr'
                      inputLabel={
                        <>
                          {t('BUILDING') + t('O_ARABIC')}
                          {/* <span className='text-red-500'>*</span> */}
                        </>
                      }
                      type='text'
                      register={register(
                        'buildingAr',
                        //  formValidation.building
                      )}
                      errors={errors}
                    />
                  </label>
                </div>
                <div className='mb-3'>
                  <label className='block'>
                    <OInputField
                      wrapperClassName='relative z-0   w-full group'
                      name='unitNumber'
                      inputLabel={
                        <>
                          {t('UNIT_NUMBER')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='text'
                      register={register(
                        'unitNumber',
                        formValidation.unitNumber,
                      )}
                      errors={errors}
                    />
                  </label>
                </div>

                <div className='mb-3'>
                  <label className='block'>
                    <OInputField
                      wrapperClassName='relative z-0   w-full group'
                      name='street'
                      inputLabel={
                        <>
                          {t('STREET')}
                          {/* <span className='text-red-500'>*</span> */}
                        </>
                      }
                      type='text'
                      register={register('street')}
                      errors={errors}
                    />
                  </label>
                </div>
                <div className='mb-3'>
                  <label className='block'>
                    <OInputField
                      wrapperClassName='relative z-0   w-full group'
                      name='streetAr'
                      inputLabel={
                        <>
                          {t('STREET') + t('O_ARABIC')}
                          {/* <span className='text-red-500'>*</span> */}
                        </>
                      }
                      type='text'
                      register={register('streetAr')}
                      errors={errors}
                    />
                  </label>
                </div>
                <div className='mb-3'>
                  <label className='block'>
                    <OInputField
                      wrapperClassName='relative z-0   w-full group'
                      name='licenseNumber'
                      inputLabel={
                        <>
                          {t('LICENSE_NUMBER')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='text'
                      register={register(
                        'licenseNumber',
                        formValidation.licenseNumber,
                      )}
                      errors={errors}
                    />
                  </label>
                </div>
                <div className='mb-3 '>
                  <OSelect
                    wrapperClassName='relative z-0  w-full group'
                    name='availableStatus'
                    inputLabel={
                      <>
                        {t('AVAILABLE_STATUS')}
                        <span className='text-red-500'>*</span>
                      </>
                    }
                    type='select'
                    options={availableOption}
                    placeholder={t('AVAILABLE_STATUS')}
                    register={register(
                      'availableStatus',
                      formValidation.availableStatus,
                    )}
                    errors={errors}
                  />
                  {/* <div className='relative z-0  w-full group'>
                    <label
                      htmlFor='availableStatus'
                      className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
                    >
                      {t('AVAILABLE_STATUS')}
                       <span className='text-red-500'>*</span> 
                    </label>

                    <select
                      className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                      value={selectedCity}
                      id='availableStatus'
                      {...register('availableStatus', {
                        // required: {
                        //   value: true,
                        //   message: 'Please select city..'
                        // },
                        onChange: e => handleCitySelect(e)
                      })}
                      placeholder=' '
                    >
                      <option value=''>{t('AVAILABLE_STATUS')}</option>
                      {availableOption.map(newCity => (
                        <option key={newCity?._id} value={newCity?._id}>
                          {newCity?.name}
                        </option>
                      ))}
                    </select>
                    <ErrorMessage message={errors?.cityId?.message} />
                  </div> */}
                </div>
                <div className='mb-3'>
                  <label className='block'>
                    <OInputField
                      wrapperClassName='relative z-0   w-full group'
                      name='appBrochure'
                      inputLabel='App Brochure'
                      type='text'
                      register={register(
                        'appBrochure',
                        formValidation.appBrochure,
                      )}
                      errors={errors}
                    />
                  </label>
                </div>
                <div className='mb-3'>
                  <label className='block'>
                    <OInputField
                      wrapperClassName='relative z-0   w-full group'
                      name='url360'
                      inputLabel='360 URL'
                      type='text'
                      register={register('url360')}
                      errors={errors}
                    />
                  </label>
                </div>
                <div className='px-2'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='latitude'
                    inputLabel={
                      <>
                        {t('O_LATITUDE')}
                        <span className='text-red-500'>*</span>
                      </>
                    }
                    type='number'
                    // register={register('latitude')}
                    register={register('latitude', formValidation.latitude)}
                    errors={errors}
                  />
                </div>
                <div className='px-2'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='longitude'
                    inputLabel={
                      <>
                        {t('O_LONGITUDE')}
                        <span className='text-red-500'>*</span>
                      </>
                    }
                    type='number'
                    register={register('longitude', formValidation.longitude)}
                    errors={errors}
                  />
                </div>

                <div className='mb-3 '>
                  <OSelect
                    wrapperClassName='relative z-0  w-full group'
                    name='purposeType'
                    inputLabel={
                      <>
                        {t('SELECT_PURPOSE_TYPE')}
                        {/* <span className='text-red-500'>*</span> */}
                      </>
                    }
                    type='select'
                    options={purposeTypeOption}
                    selected={editProperty?.purposeType ?? ''}
                    defaultValue={t('SELECT_PURPOSE_TYPE')}
                    register={register('purposeType')}
                    errors={errors}
                  />
                </div>
                <div className='mb-3 '>
                  <OSelect
                    wrapperClassName='relative z-0  w-full group'
                    name='projectOrder'
                    inputLabel={
                      <>
                        {t('SELECT_ORDER')}
                        {/* <span className='text-red-500'>*</span> */}
                      </>
                    }
                    type='select'
                    options={projectOrderOption}
                    defaultValue={t('SELECT_ORDER')}
                    register={register('projectOrder')}
                    errors={errors}
                  />
                </div>
                <div className='mb-3 '>
                  <OInputField
                    wrapperClassName='relative z-0  w-full group'
                    name='cameraZoomLevel'
                    inputLabel={
                      <>
                        {t('CAMERA_ZOOM_LEVEL')} (1-20)
                        {/* <span className='text-red-500'>*</span> */}
                      </>
                    }
                    type='number'
                    register={register('cameraZoomLevel')}
                    errors={errors}
                    min={1}
                    max={20}
                    placeholder={t('CAMERA_ZOOM_LEVEL')}
                  />
                </div>
                <div className='mb-3 gap-2'>
                  <label className='block'>{t('CAMERA_POSITION')}</label>
                  <div className='flex gap-2'>
                    <div>
                      <OInputField
                        wrapperClassName='relative z-0  w-full group'
                        name='cameraPosition.latitude'
                        register={register('cameraPosition.latitude', {
                          validate: (value) => {
                            if (value.trim() && !isValidLatitude(value)) {
                              return 'Please enter valid latitude';
                            }
                            return true;
                          },
                        })}
                        errors={errors}
                        type='text'
                        placeholder={t('O_LATITUDE')}
                      />
                      <ErrorMessage
                        message={errors['cameraPosition']?.latitude?.message}
                      />
                    </div>
                    <div>
                      <OInputField
                        wrapperClassName='relative z-0  w-full group'
                        name='cameraPosition.longitude'
                        register={register('cameraPosition.longitude', {
                          validate: (value) => {
                            if (value.trim() && !isValidLongitude(value)) {
                              return 'Please enter valid longitude';
                            }
                            return true;
                          },
                        })}
                        type='text'
                        placeholder={t('O_LONGITUDE')}
                      />
                      <ErrorMessage
                        message={errors['cameraPosition']?.longitude?.message}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className='mb-3 '>
                <span className='block text-sm font-medium'>
                  {t('O_NEAREST_FACILITIES')}
                </span>
                <TagsInput
                  classNames={{
                    input:
                      'w-full h-9 --rti-border: bg-transparent border-2 rounded-lg border-[#DFDFDF]  ',
                  }}
                  value={nearestFacility}
                  onChange={(value) => {
                    setNearestFacility(value);
                    // setIsNearestFacilityError(false)
                  }}
                  name='nearestFacility'
                  placeHolder={t('PRESS_ENTER_TO_ADD_MORE_NEAREST_FACILITIES')}
                />
              </div>
              <div className='mb-3 '>
                <span className='block text-sm font-medium'>
                  {t('O_NEAREST_FACILITIES') + t('O_ARABIC')}
                </span>
                <TagsInput
                  classNames={{
                    input:
                      'w-full h-9 --rti-border: bg-transparent border-2 rounded-lg border-[#DFDFDF]  ',
                  }}
                  value={nearestFacilityAr}
                  onChange={(item) => {
                    setNearestFacilityAr(item);
                    // setIsNearestFacilityArError(false)
                  }}
                  name='nearestFacilityAr'
                  placeHolder={
                    t('PRESS_ENTER_TO_ADD_MORE_NEAREST_FACILITIES') +
                    t('O_ARABIC')
                  }
                />
              </div>
              <div className='py-3 mb-1 max-w-md'>
                <span className='block text-sm font-medium'>
                  {t('UPLOAD_BROCHURE')}
                </span>
                <div className='flex gap-4'>
                  <label className='block w-full'>
                    <div className='flex border rounded-md overflow-hidden mt-1'>
                      <span
                        className=' px-3 cursor-pointer py-3 bg-white border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full sm:text-sm focus:ring-1'
                        // onClick={() => videoRef?.current?.click()}
                      >
                        {developerDoc
                          ? developerDoc?.name
                          : t('UPLOAD_BROCHURE')}
                      </span>
                      <input
                        type='file'
                        name='developerDoc'
                        accept='.pdf, .doc, .docx'
                        // ref={videoRef}
                        onChange={(e) => handleBrochureChange(e)}
                        onClick={(e) => (e.target.value = null)}
                        className='hidden'
                      />
                      <span
                        className='flex items-center justify-center bg-lime-500 text-white text-sm rounded-r w-[84px]'
                        // onClick={() => videoRef?.current?.click()}
                      >
                        Upload
                      </span>
                    </div>
                  </label>
                  {editProperty?.developerDoc && (
                    <div className='flex items-center justify-center gap-2'>
                      <a
                        href={editProperty?.developerDoc}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='flex items-center justify-center text-lime-500'>
                        <BsEye />
                      </a>
                      <button
                        type='button'
                        className='flex items-center justify-center text-red-500'
                        onClick={() => handleDeleteAttachment('developerDoc')}>
                        <BiTrash />
                      </button>
                    </div>
                  )}
                </div>

                <div className='text-center mt-4'>
                  <ErrorMessage message={developerDocError} />
                </div>
              </div>
              <div className='py-3 mb-1 max-w-md'>
                <span className='block text-sm font-medium'>
                  {t('PROJECT_FLOOR_PLAN')}
                </span>
                <div className='flex gap-4'>
                  <label className='block w-full'>
                    <div className='flex border rounded-md overflow-hidden mt-1'>
                      <span
                        className=' px-3 cursor-pointer py-3 bg-white border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full sm:text-sm focus:ring-1'
                        // onClick={() => videoRef?.current?.click()}
                      >
                        {projectFloorPlan
                          ? projectFloorPlan?.name
                          : t('PROJECT_FLOOR_PLAN')}
                      </span>
                      <input
                        type='file'
                        name='projectFloorPlan'
                        accept='.pdf, .doc, .docx'
                        // ref={videoRef}
                        onChange={(e) => handleProjectFloorPlanChange(e)}
                        onClick={(e) => (e.target.value = null)}
                        className='hidden'
                      />
                      <span
                        className='flex items-center justify-center bg-lime-500 text-white text-sm rounded-r w-[84px]'
                        // onClick={() => videoRef?.current?.click()}
                      >
                        Upload
                      </span>
                    </div>
                  </label>
                  {editProperty?.projectFloorPlan && (
                    <div className='flex items-center justify-center gap-2'>
                      <a
                        href={editProperty?.projectFloorPlan}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='flex items-center justify-center text-lime-500'>
                        <BsEye />
                      </a>
                      <button
                        type='button'
                        className='flex items-center justify-center text-red-500'
                        onClick={() =>
                          handleDeleteAttachment('projectFloorPlan')
                        }>
                        <BiTrash />
                      </button>
                    </div>
                  )}
                </div>
                <div className='text-center mt-4'>
                  <ErrorMessage message={projectFloorPlanError} />
                </div>
              </div>
              <div className='py-3 mb-1 max-w-md'>
                <span className='block text-sm font-medium'>
                  {t('UPLOAD_PAYMENT_PLAN')}
                </span>
                <div className='flex gap-4'>
                  <label className='block w-full'>
                    <div className='flex border rounded-md overflow-hidden mt-1'>
                      <span
                        className=' px-3 cursor-pointer py-3 bg-white border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full sm:text-sm focus:ring-1'
                        // onClick={() => videoRef?.current?.click()}
                      >
                        {paymentPlan
                          ? paymentPlan?.name
                          : t('UPLOAD_PAYMENT_PLAN')}
                      </span>
                      <input
                        type='file'
                        name='paymentPlan'
                        accept='.pdf, .doc, .docx'
                        // ref={videoRef}
                        onChange={(e) => handlePaymentPlanChange(e)}
                        onClick={(e) => (e.target.value = null)}
                        className='hidden'
                      />
                      <span
                        className='flex items-center justify-center bg-lime-500 text-white text-sm rounded-r w-[84px]'
                        // onClick={() => videoRef?.current?.click()}
                      >
                        Upload
                      </span>
                    </div>
                  </label>
                  {editProperty?.paymentPlan && (
                    <div className='flex items-center justify-center gap-2'>
                      <a
                        href={editProperty?.paymentPlan}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='flex items-center justify-center text-lime-500'>
                        <BsEye />
                      </a>
                      <button
                        type='button'
                        className='flex items-center justify-center text-red-500'
                        onClick={() => handleDeleteAttachment('paymentPlan')}>
                        <BiTrash />
                      </button>
                    </div>
                  )}
                </div>
                <div className='text-center mt-4'>
                  <ErrorMessage message={paymentPlanError} />
                </div>
              </div>
              <div className='py-3 mb-1 max-w-md'>
                <span className='block text-sm font-medium'>{t('EDM')}</span>
                <div className='flex gap-4'>
                  <label className='block w-full'>
                    <div className='flex border rounded-md overflow-hidden mt-1'>
                      <span
                        className=' px-3 cursor-pointer py-3 bg-white border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full sm:text-sm focus:ring-1'
                        // onClick={() => videoRef?.current?.click()}
                      >
                        {edm ? edm?.name : t('EDM')}
                      </span>
                      <input
                        type='file'
                        name='edm'
                        accept='.pdf, .doc, .docx'
                        // ref={videoRef}
                        onChange={(e) => handleEdmChange(e)}
                        onClick={(e) => (e.target.value = null)}
                        className='hidden'
                      />
                      <span
                        className='flex items-center justify-center bg-lime-500 text-white text-sm rounded-r w-[84px]'
                        // onClick={() => videoRef?.current?.click()}
                      >
                        Upload
                      </span>
                    </div>
                  </label>
                  {editProperty?.edm && (
                    <div className='flex items-center justify-center gap-2'>
                      <a
                        href={editProperty?.edm}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='flex items-center justify-center text-lime-500'>
                        <BsEye />
                      </a>
                      <button
                        type='button'
                        className='flex items-center justify-center text-red-500'
                        onClick={() => handleDeleteAttachment('edm')}>
                        <BiTrash />
                      </button>
                    </div>
                  )}
                </div>
                <div className='text-center mt-4'>
                  <ErrorMessage message={edmError} />
                </div>
              </div>
              <div className='py-3 mb-1 max-w-md'>
                <span className='block text-sm font-medium'>
                  {t('CONTRACT')}
                </span>
                <div className='flex gap-4'>
                  <label className='block w-full'>
                    <div className='flex border rounded-md overflow-hidden mt-1'>
                      <span className=' px-3 cursor-pointer py-3 bg-white border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full sm:text-sm focus:ring-1'>
                        {contractFiles.length
                          ? `${contractFiles.length} file(s) selected`
                          : t('CONTRACT')}
                      </span>
                      <input
                        type='file'
                        name='contract'
                        accept='.pdf, .doc, .docx'
                        multiple
                        onChange={(e) => handleContractChange(e)}
                        onClick={(e) => (e.target.value = null)}
                        className='hidden'
                      />
                      <span className='flex items-center justify-center bg-lime-500 text-white text-sm rounded-r w-[84px]'>
                        Upload
                      </span>
                    </div>
                  </label>
                </div>
                {(existingContracts.length > 0 || contractFiles.length > 0) && (
                  <div className='mt-2 space-y-2'>
                    {existingContracts.map((url) => (
                      <div
                        key={url}
                        className='flex items-center justify-between gap-2'>
                        <span className='text-sm truncate'>
                          {String(url).split('/').pop()}
                        </span>
                        <div className='flex items-center justify-center gap-2'>
                          <a
                            href={url}
                            target='_blank'
                            rel='noopener noreferrer'
                            className='flex items-center justify-center text-lime-500'>
                            <BsEye />
                          </a>
                          <button
                            type='button'
                            className='flex items-center justify-center text-red-500'
                            onClick={() => removeExistingContract(url)}>
                            <BiTrash />
                          </button>
                        </div>
                      </div>
                    ))}
                    {contractFiles.map((file, index) => (
                      <div
                        key={`${file.name}-${index}`}
                        className='flex items-center justify-between gap-2'>
                        <span className='text-sm truncate'>{file.name}</span>
                        <button
                          type='button'
                          className='flex items-center justify-center text-red-500'
                          onClick={() => removeNewContract(index)}>
                          <BiTrash />
                        </button>
                      </div>
                    ))}
                  </div>
                )}
                <div className='text-center mt-4'>
                  <ErrorMessage message={contractError} />
                </div>
              </div>
              <h4 className='text-lg font-semibold py-3'>
                Nearest Facility App
              </h4>
              {nearestFacilityApp?.length > 0 &&
                nearestFacilityApp?.map((item, index) => {
                  return (
                    <div
                      className='flex gap-4 xl:gap-12  w-auto inline-block px-3 mb-2 rounded-sm'
                      key={index}>
                      <div className='py-3 mb-1 flex-0 w-1/2 xl:w-1/2'>
                        <label className='block'>
                          <span className='block text-sm font-medium mb-2'>
                            Name
                          </span>
                          <input
                            type='text'
                            name='name'
                            className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                            // placeholder={t('O_TITLE')}
                            value={item?.name}
                            onChange={(e) => {
                              setNearestFacilityApp(
                                nearestFacilityApp?.map((res, ind) => {
                                  if (ind === index) {
                                    return {
                                      ...res,
                                      name: e.target.value,
                                    };
                                  } else {
                                    return res;
                                  }
                                }),
                              );
                            }}
                          />
                        </label>
                      </div>
                      <div className='py-3 mb-1 flex-0 w-1/2 xl:w-1/2'>
                        <label className='block'>
                          <span className='block text-sm font-medium mb-2'>
                            Distance
                          </span>
                          <input
                            type='text'
                            name='distance'
                            className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                            // placeholder={t('O_TITLE')}
                            value={item?.distance}
                            onChange={(e) => {
                              setNearestFacilityApp(
                                nearestFacilityApp?.map((res, ind) => {
                                  if (ind === index) {
                                    return {
                                      ...res,
                                      distance: e.target.value,
                                    };
                                  } else {
                                    return res;
                                  }
                                }),
                              );
                            }}
                          />
                        </label>
                      </div>
                      <div className='flex items-center'>
                        <button
                          type='button'
                          className='ml-3  text-black rounded-full text-xxl leading-none font-extralight outline-none focus:outline-none mt-3  bg-blue-200 w-[40px] h-[40px]'
                          onClick={() =>
                            deleteMore('nearestFacilityApp', index)
                          }>
                          <span
                            className=' text-[#222]  text-lg '
                            title='Close'>
                            ×
                          </span>
                        </button>
                      </div>
                    </div>
                  );
                })}
              <button
                className='text-blue-400'
                type='button'
                onClick={() => addMoreNearestFacilityApp()}>
                {t('ADD')}
              </button>

              <h4 className='text-lg font-semibold py-3'>
                Nearest Facility App (Arbic)
              </h4>
              {nearestFacilityAppAr?.length > 0 &&
                nearestFacilityAppAr?.map((item, index) => {
                  return (
                    <div
                      className='flex gap-4 xl:gap-12  w-auto inline-block px-3 mb-2 rounded-sm'
                      key={index}>
                      <div className='py-3 mb-1 flex-0 w-1/2 xl:w-1/2'>
                        <label className='block'>
                          <span className='block text-sm font-medium mb-2'>
                            Name
                          </span>
                          <input
                            type='text'
                            name='name'
                            className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                            // placeholder={t('O_TITLE')}
                            value={item?.name}
                            onChange={(e) => {
                              setNearestFacilityAppAr(
                                nearestFacilityAppAr?.map((res, ind) => {
                                  if (ind === index) {
                                    return {
                                      ...res,
                                      name: e.target.value,
                                    };
                                  } else {
                                    return res;
                                  }
                                }),
                              );
                            }}
                          />
                        </label>
                      </div>
                      <div className='py-3 mb-1 flex-0 w-1/2 xl:w-1/2'>
                        <label className='block'>
                          <span className='block text-sm font-medium mb-2'>
                            Distance
                          </span>
                          <input
                            type='text'
                            name='distance'
                            className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                            // placeholder={t('O_TITLE')}
                            value={item?.distance}
                            onChange={(e) => {
                              setNearestFacilityAppAr(
                                nearestFacilityAppAr?.map((res, ind) => {
                                  if (ind === index) {
                                    return {
                                      ...res,
                                      distance: e.target.value,
                                    };
                                  } else {
                                    return res;
                                  }
                                }),
                              );
                            }}
                          />
                        </label>
                      </div>
                      <div className='flex items-center'>
                        <button
                          type='button'
                          className='ml-3  text-black rounded-full text-xxl leading-none font-extralight outline-none focus:outline-none mt-3  bg-blue-200 w-[40px] h-[40px]'
                          onClick={() =>
                            deleteMore('nearestFacilityAppAr', index)
                          }>
                          <span
                            className=' text-[#222]  text-lg '
                            title='Close'>
                            ×
                          </span>
                        </button>
                      </div>
                    </div>
                  );
                })}
              <button
                className='text-blue-400'
                type='button'
                onClick={() => addMoreNearestFacilityApp('ar')}>
                {t('ADD')}
              </button>

              <div className='grid grid-rows-1 grid-cols-3 gap-4'>
                <div className='mb-3 '>
                  <p className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
                    Is Exclusive
                  </p>
                  <label
                    className='inline-flex relative items-center cursor-pointer'
                    title='Is Exclusive'
                    // title={`${
                    //   item?.status === 'yes' ? 'Yes' : 'No'
                    // }`}
                  >
                    <input
                      type='checkbox'
                      // value="yes"
                      className='sr-only peer'
                      checked={isExclusive}
                      id='isExclusive'
                      name='isExclusive'
                      onChange={(e) => setIsExclusive(e.target.checked)}
                    />
                    <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                  </label>
                </div>
                <div className='mb-3 '>
                  <p className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
                    Is Most Popular
                  </p>
                  <label
                    className='inline-flex relative items-center cursor-pointer'
                    title='Is Most Popular'
                    // title={`${
                    //   item?.status === 'yes' ? 'Yes' : 'No'
                    // }`}
                  >
                    <input
                      type='checkbox'
                      // value="yes"
                      className='sr-only peer'
                      checked={isMostPopular}
                      id='isMostPopular'
                      name='isMostPopular'
                      onChange={(e) => setIsMostPopular(e.target.checked)}
                    />
                    <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                  </label>
                </div>
                <div className='mb-3 '>
                  <p className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
                    Pre Launch
                  </p>
                  <label
                    className='inline-flex relative items-center cursor-pointer'
                    title='Pre Launch'
                    // title={`${
                    //   item?.status === 'yes' ? 'Yes' : 'No'
                    // }`}
                  >
                    <input
                      type='checkbox'
                      // value="yes"
                      className='sr-only peer'
                      checked={preLaunch}
                      id='preLaunch'
                      name='preLaunch'
                      onChange={(e) => setPreLaunch(e.target.checked)}
                    />
                    <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                  </label>
                </div>
                <div className='mb-3 '>
                  <p className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
                    Show On Map
                  </p>
                  <label
                    className='inline-flex relative items-center cursor-pointer'
                    title='Show On Map'
                    // title={`${
                    //   item?.status === 'yes' ? 'Yes' : 'No'
                    // }`}
                  >
                    <input
                      type='checkbox'
                      // value="yes"
                      className='sr-only peer'
                      checked={showOnMap}
                      id='showOnMap'
                      name='showOnMap'
                      onChange={(e) => setShowOnMap(e.target.checked)}
                    />
                    <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                  </label>
                </div>
                <div className='mb-3 '>
                  <p className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
                    Signature
                  </p>
                  <label
                    className='inline-flex relative items-center cursor-pointer'
                    title='Signature'
                    // title={`${
                    //   item?.status === 'yes' ? 'Yes' : 'No'
                    // }`}
                  >
                    <input
                      type='checkbox'
                      // value="yes"
                      className='sr-only peer'
                      checked={isSignature}
                      id='isSignature'
                      name='isSignature'
                      onChange={(e) => setIsSignature(e.target.checked)}
                    />
                    <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                  </label>
                </div>
              </div>

              <h4 className='text-lg font-semibold py-3'>
                Project Display Option
              </h4>
              <div className='grid grid-rows-1 grid-cols-3 gap-4'>
                <div className='mb-3 '>
                  <p className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
                    Show In Website
                  </p>
                  <label
                    className='inline-flex relative items-center cursor-pointer'
                    title='Show In Website'
                    // title={`${
                    //   item?.status === 'yes' ? 'Yes' : 'No'
                    // }`}
                  >
                    <input
                      type='checkbox'
                      // value="yes"
                      className='sr-only peer'
                      checked={projectShowInWebsite}
                      id='projectShowInWebsite'
                      name='projectShowInWebsite'
                      onChange={(e) =>
                        setProjectShowInWebsite(e.target.checked)
                      }
                    />
                    <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                  </label>
                </div>
                <div className='mb-3 '>
                  <p className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
                    Show In Agent App
                  </p>
                  <label
                    className='inline-flex relative items-center cursor-pointer'
                    title='Show In Agent App'
                    // title={`${
                    //   item?.status === 'yes' ? 'Yes' : 'No'
                    // }`}
                  >
                    <input
                      type='checkbox'
                      // value="yes"
                      className='sr-only peer'
                      checked={projectShowInAgentApp}
                      id='projectShowInAgentApp'
                      name='projectShowInAgentApp'
                      onChange={(e) =>
                        setProjectShowInAgentApp(e.target.checked)
                      }
                    />
                    <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                  </label>
                </div>
                <div className='mb-3 '>
                  <p className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
                    Show In Customer App
                  </p>
                  <label
                    className='inline-flex relative items-center cursor-pointer'
                    title='Show In Customer App'
                    // title={`${
                    //   item?.status === 'yes' ? 'Yes' : 'No'
                    // }`}
                  >
                    <input
                      type='checkbox'
                      // value="yes"
                      className='sr-only peer'
                      checked={projectShowInCustomerApp}
                      id='projectShowInCustomerApp'
                      name='projectShowInCustomerApp'
                      onChange={(e) =>
                        setProjectShowInCustomerApp(e.target.checked)
                      }
                    />
                    <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                  </label>
                </div>
              </div>

              <h4 className='text-lg font-semibold py-3'>
                Unit Display Option
              </h4>
              <div className='grid grid-rows-1 grid-cols-3 gap-4'>
                <div className='mb-3 '>
                  <p className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
                    Show In Website
                  </p>
                  <label
                    className='inline-flex relative items-center cursor-pointer'
                    title='Show In Website'
                    // title={`${
                    //   item?.status === 'yes' ? 'Yes' : 'No'
                    // }`}
                  >
                    <input
                      type='checkbox'
                      // value="yes"
                      className='sr-only peer'
                      checked={showInWebsite}
                      id='showInWebsite'
                      name='showInWebsite'
                      onChange={(e) => setShowInWebsite(e.target.checked)}
                    />
                    <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                  </label>
                </div>
                <div className='mb-3 '>
                  <p className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
                    Show In Agent App
                  </p>
                  <label
                    className='inline-flex relative items-center cursor-pointer'
                    title='Show In Agent App'
                    // title={`${
                    //   item?.status === 'yes' ? 'Yes' : 'No'
                    // }`}
                  >
                    <input
                      type='checkbox'
                      // value="yes"
                      className='sr-only peer'
                      checked={showInAgentApp}
                      id='showInAgentApp'
                      name='showInAgentApp'
                      onChange={(e) => setShowInAgentApp(e.target.checked)}
                    />
                    <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                  </label>
                </div>
                <div className='mb-3 '>
                  <p className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
                    Show In Customer App
                  </p>
                  <label
                    className='inline-flex relative items-center cursor-pointer'
                    title='Show In Customer App'
                    // title={`${
                    //   item?.status === 'yes' ? 'Yes' : 'No'
                    // }`}
                  >
                    <input
                      type='checkbox'
                      // value="yes"
                      className='sr-only peer'
                      checked={showInCustomerApp}
                      id='showInCustomerApp'
                      name='showInCustomerApp'
                      onChange={(e) => setShowInCustomerApp(e.target.checked)}
                    />
                    <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                  </label>
                </div>
              </div>

              <h4 className='text-lg font-semibold py-3'>
                Freelancer Asset Access
              </h4>
              <div className='grid grid-rows-1 grid-cols-3 gap-4'>
                <div className='mb-3 '>
                  <p className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
                    Show Brochure
                  </p>
                  <label
                    className='inline-flex relative items-center cursor-pointer'
                    title='Show Brochure'>
                    <input
                      type='checkbox'
                      className='sr-only peer'
                      checked={showBrochureToFreelancer}
                      id='showBrochureToFreelancer'
                      name='showBrochureToFreelancer'
                      onChange={(e) =>
                        setShowBrochureToFreelancer(e.target.checked)
                      }
                    />
                    <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                  </label>
                </div>
                <div className='mb-3 '>
                  <p className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
                    Show Floor Plan
                  </p>
                  <label
                    className='inline-flex relative items-center cursor-pointer'
                    title='Show Floor Plan'>
                    <input
                      type='checkbox'
                      className='sr-only peer'
                      checked={showFloorPlanToFreelancer}
                      id='showFloorPlanToFreelancer'
                      name='showFloorPlanToFreelancer'
                      onChange={(e) =>
                        setShowFloorPlanToFreelancer(e.target.checked)
                      }
                    />
                    <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                  </label>
                </div>
                <div className='mb-3 '>
                  <p className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
                    Show Payment Plan
                  </p>
                  <label
                    className='inline-flex relative items-center cursor-pointer'
                    title='Show Payment Plan'>
                    <input
                      type='checkbox'
                      className='sr-only peer'
                      checked={showPaymentPlanToFreelancer}
                      id='showPaymentPlanToFreelancer'
                      name='showPaymentPlanToFreelancer'
                      onChange={(e) =>
                        setShowPaymentPlanToFreelancer(e.target.checked)
                      }
                    />
                    <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                  </label>
                </div>
                <div className='mb-3 '>
                  <p className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
                    Show EDM
                  </p>
                  <label
                    className='inline-flex relative items-center cursor-pointer'
                    title='Show EDM'>
                    <input
                      type='checkbox'
                      className='sr-only peer'
                      checked={showEdmToFreelancer}
                      id='showEdmToFreelancer'
                      name='showEdmToFreelancer'
                      onChange={(e) => setShowEdmToFreelancer(e.target.checked)}
                    />
                    <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                  </label>
                </div>
                <div className='mb-3 '>
                  <p className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
                    Show Art Gallery
                  </p>
                  <label
                    className='inline-flex relative items-center cursor-pointer'
                    title='Show Art Gallery'>
                    <input
                      type='checkbox'
                      className='sr-only peer'
                      checked={showArtGalleryToFreelancer}
                      id='showArtGalleryToFreelancer'
                      name='showArtGalleryToFreelancer'
                      onChange={(e) =>
                        setShowArtGalleryToFreelancer(e.target.checked)
                      }
                    />
                    <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                  </label>
                </div>
                <div className='mb-3 '>
                  <p className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
                    Show Video
                  </p>
                  <label
                    className='inline-flex relative items-center cursor-pointer'
                    title='Show Video'>
                    <input
                      type='checkbox'
                      className='sr-only peer'
                      checked={showVideoToFreelancer}
                      id='showVideoToFreelancer'
                      name='showVideoToFreelancer'
                      onChange={(e) =>
                        setShowVideoToFreelancer(e.target.checked)
                      }
                    />
                    <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                  </label>
                </div>
              </div>

              {config?.country === 'Saudi' && (
                <div className='grid grid-cols-1 lg:grid-cols-2'>
                  <div className='py-3 mb-1 flex-0'>
                    <label className='block'>
                      <span className='block text-sm font-medium'>
                        {t('O_WAFI_LOGO')}
                      </span>
                      <div className='flex items-center'>
                        <div className='truncate relative flex border rounded-md overflow-hidden mt-1'>
                          <span className='absolute p-3 pr-9 left-0 right-0 top-auto truncate'>
                            {t('UPLOAD_WAFI_LOGO')}
                          </span>
                          <input
                            type='file'
                            accept='image/png, image/jpg, image/jpeg'
                            name='image'
                            placeholder='10.95'
                            onChange={(e) => handleWafiFiles('image', e)}
                            className='opacity-0 px-3 py-3 bg-transparent relative z-10 border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full sm:text-sm focus:ring-1'
                          />
                          <button className='flex items-center justify-center absolute right-0 top-4 text-white text-sm rounded-r w-[40px] bg-white'>
                            <img src='../images/upload.svg' alt='' />
                          </button>
                        </div>
                        <div className='flex items-center'>
                          {wafiFiles?.logo && (
                            <div className=' ml-3 h-16 w-16 overflow-hidden border-4  rounded-full'>
                              <img
                                src={
                                  typeof wafiFiles?.logo === 'object'
                                    ? URL.createObjectURL(wafiFiles?.logo)
                                    : wafiFiles?.logo
                                }
                                alt=''
                                className='w-full h-full object-cover'
                              />
                            </div>
                          )}
                          <button
                            type='button'
                            className='ml-3  text-black rounded-full text-xxl leading-none font-extralight outline-none focus:outline-none mt-3  bg-blue-200 w-[40px] h-[40px]'
                            onClick={() => handleDeleteWafiFiles('image')}>
                            <span
                              className=' text-[#222]  text-lg '
                              title='Close'>
                              ×
                            </span>
                          </button>
                        </div>
                      </div>
                    </label>
                  </div>
                  <div className='py-3 mb-1 flex-0'>
                    <label className='block'>
                      <span className='block text-sm font-medium'>
                        {t('O_WAFI_CONTRACT')}
                      </span>
                      <div className='flex items-center'>
                        <div className='truncate relative flex border rounded-md overflow-hidden mt-1'>
                          <span className='absolute p-3 pr-9 left-0 right-0 top-auto truncate'>
                            {t('UPLOAD_WAFI_CONTRACT')}
                          </span>
                          <input
                            type='file'
                            name='contract'
                            accept='.pdf'
                            placeholder='10.95'
                            onChange={(e) => handleWafiFiles('pdf', e)}
                            className='opacity-0 px-3 py-3 bg-transparent relative z-10 border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full sm:text-sm focus:ring-1'
                          />
                          <button className='flex items-center justify-center absolute right-0 top-4 text-white text-sm rounded-r w-[40px] bg-white'>
                            <img src='../images/upload.svg' alt='' />
                          </button>
                        </div>
                        <div className='flex justify-center items-center'>
                          {wafiFiles?.contract && (
                            <div className='flex flex-col items-center w-[120px] ml-6 '>
                              <FaFilePdf className='h-[36px] w-[36px]' />
                              <span className='text-sm truncate w-[100px] overflow-hidden whitespace-nowrap text-ellipsis'>
                                {wafiFiles?.contractName}
                              </span>
                            </div>
                          )}
                          <button
                            type='button'
                            className='ml-3  text-black rounded-full text-xxl leading-none font-extralight outline-none focus:outline-none mt-3  bg-blue-200 w-[40px] h-[40px]'
                            onClick={() => handleDeleteWafiFiles('pdf')}>
                            <span
                              className=' text-[#222]  text-lg '
                              title='Close'>
                              ×
                            </span>
                          </button>
                        </div>
                      </div>
                    </label>
                  </div>
                  <div className='grid grid-rows-1 grid-cols-3 gap-4 w-full'>
                    <div className='mb-3 '>
                      <p className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
                        Send Users Notifications
                      </p>
                      <label
                        className='inline-flex relative items-center cursor-pointer'
                        title='Send users notifications'
                        // title={`${
                        //   item?.status === 'yes' ? 'Yes' : 'No'
                        // }`}
                      >
                        <input
                          type='checkbox'
                          // value="yes"
                          className='sr-only peer'
                          checked={isNotify}
                          id='isNotify'
                          name='isNotify'
                          onChange={(e) => setisNotify(e.target.checked)}
                        />
                        <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                      </label>
                    </div>
                  </div>
                </div>
              )}

              {/* <div className='mb-3 max-w-[66%]'>
                <label className='block'>
                  <span className='block text-sm font-medium text-gray-400'>
                    {t('O_NEAREST_FACILITIES') + t('O_ARABIC')}
                  </span>
                  <textarea
                    type='text'
                    name='email'
                    className='mt-1 h-[120px] px-3 py-3 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1'
                    placeholder={
                      t('O_NEAREST_FACILITIES_PLACE_HOLDER') + t('O_ARABIC')
                    }
                    {...register('nearestFacilitiesAr', {
                      required: {
                        value: true,
                        message: 'Please enter nearest facilities in arabic.'
                      }
                    })}
                  />
                  <ErrorMessage
                    message={errors?.nearestFacilitiesAr?.message}
                  />
                </label>
              </div> */}
            </form>
            <div className='border-t mt-10 py-10 text-center'>
              <button className='bg-lime-500 hover:bg-[#8FC150] cursor-pointer   text-white  font-normal active:bg-slate-100 text-md px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150'>
                {t('SAVE_&_CONTINUE')}
              </button>
            </div>
          </div>
        </form>
      </div>
      {isAmenities && (
        <OAmenities
          propertyAmenitiesList={propertyAmenitiesList}
          setIsAmenities={setIsAmenities}
          setPropertyAmenities={setPropertyAmenities}
          propertyAmenities={propertyAmenities}
          setIsAmenity={setIsAmenity}
        />
      )}
      {isPropertyCategories && (
        <OPropertyCategories
          propertyCategoryTypes={propertyCategoryTypes}
          setIsPropertyCategories={setIsPropertyCategories}
          propertyCategoryType={propertyCategoryType}
          handleCategoryChangeType={handleCategoryChangeType}
        />
      )}
    </>
  );
};

export default AddProject;
